import {
    Box,
    Grid,
    Paper,
    Typography,
    Button,
    TextField,
    LinearProgress,
    Divider,
    Stack,
    Tooltip,
    CircularProgress,
    Modal,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel,
    GlobalStyles
} from "@mui/material";
import oceshaLogo from '../../../assets/ocesha_images/ocesha_logo.png';
import Ocesha_header from "pages/ocesha_landing/ocesha_header";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyGetProductQuery } from "redux/api/productApi";
import { useState, useEffect, ChangeEvent, ReactNode } from "react";
import { useAppSelector, useAppDispatch } from "redux/store";
import { toast } from "react-toastify";
import { removeCookie } from "utils/storageUtils";
import { logout } from "redux/features/userSlice";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useRef } from "react";
import WestIcon from '@mui/icons-material/West';
import axios from "axios";
import { useGetUserDetailsMutation } from "redux/api/authApi";
import { isMobile } from "react-device-detect";
import CloseIcon from '@mui/icons-material/Close';
import unsplashImg from '../../../assets/traffic_monster/unsplash_logo.png';
import ComputerIcon from '@mui/icons-material/Computer';
import SearchIcon from '@mui/icons-material/Search';
import unsplash_logo from '../../../assets/traffic_monster/unsplash_logo.png';
import GBALogo from '../../../assets/traffic_monster/GBA_Logo.png';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { marked } from "marked";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { redirectAfterLogout } from "../../../utils/logoutRedirect";

/**
 * EditableFieldWrapper
 * ---------------------------------------------------------------
 * Wrap any editable field (TextField, ReactQuill, list editor, etc.)
 * with this component to get a small pencil/edit icon that appears
 * in the top-right corner of the field whenever the user hovers over
 * it OR has focus inside it (e.g. a TextField/ReactQuill inside it).
 *
 * Usage:
 *   <EditableFieldWrapper>
 *       <TextField ... />
 *   </EditableFieldWrapper>
 *
 * If the field sits next to (or inside a card with) a delete/remove
 * button in the same corner, pass `iconSx` to reposition the pencil
 * icon so the two don't overlap, e.g. iconSx={{ right: 36 }}.
 */
function EditableFieldWrapper({
    children,
    sx = {},
    iconSx = {},
}: {
    children: ReactNode;
    sx?: object;
    iconSx?: object;
}) {
    return (
        <Box
            sx={{
                position: "relative",
                "&:hover .editable-field-icon, &:focus-within .editable-field-icon": {
                    opacity: 1,
                },
                ...sx,
            }}
        >
            <Box
                className="editable-field-icon"
                sx={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    zIndex: 2,
                    opacity: 0,
                    transition: "opacity 0.15s ease-in-out",
                    pointerEvents: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 22,
                    height: 22,
                    borderRadius: "6px",
                    background: "rgba(37,99,235,0.1)",
                    ...iconSx,
                }}
            >
                <EditIcon sx={{ fontSize: 13, color: "#2563eb" }} />
            </Box>
            {children}
        </Box>
    );
}

interface UnsplashImage {
    id: string;
    urls: {
        thumb: string;
        regular: string;
    };
    alt_description: string;
    width: number;
    height: number;
}

const createCourseSlug = (
    title: string,
    id: string
) => {
    const slug = title
        ?.toLowerCase()
        ?.trim()
        ?.replace(/[^a-z0-9\s-]/g, "")
        ?.replace(/\s+/g, "-");

    return `${slug}-${id}`;
};

export default function CourseEditorScreen() {

    const navigate = useNavigate();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState(localStorage.getItem('activeItem') || 'dashboard');
    const genieSelector = useAppSelector((state) => state.genieState);
    const [getProduct, getProductState] = useLazyGetProductQuery();
    const dispatch = useAppDispatch();
    /* const [title, setTitle] = useState(
        "Speak & Play: Transforming Speech Therapy Access"
    ); */
    /* const [title1, setTitle1] = useState("The Market Crisis");
    const [desc1, setDesc1] = useState(
        "Over 80 million children globally face speech and language delays, yet severe shortages of speech-language pathologists create months-to-years waitlists. Limited early intervention access leaves families struggling during critical developmental windows."
    ); */
    const [getUserDetailsMutation] = useGetUserDetailsMutation();
    const [curriculum, setCurriculum] = useState<any[]>([]);
    const [activeWeekIndex, setActiveWeekIndex] = useState(0);
    const [expandedWeeks, setExpandedWeeks] = useState<number[]>([0]);
    const [courseImage, setCourseImage] = useState<any>();
    const [courseDefinitionImage, setCourseDefinitionImage] = useState<any>();
    const [courseDefinitionImageFile, setCourseDefinitionImageFile] = useState<File | null>(null);
    const [courseDetails, setCourseDetails] = useState<any>();
    const [updatingCourseDet, setUpdatingCourseDet] = useState<boolean>(false);
    const [loadingCourse, setLoadingCourse] = useState<boolean>(true);
    // true when this (live) course has saved changes that are not live yet
    const [courseHasDraft, setCourseHasDraft] = useState<boolean>(false);
    const [instructorDetails, setInstructorDetails] = useState({
        profileImage: null as File | null,
        profileImagePreview: "",
        existingImageUrl: "",
        profileUrl: "",
        profileUrl1: "",
        ctaLabel: "",
        ctaUrl: "",
        introVideo: null as File | null,
        introVideoPreview: "",
        removeVideo: false,
    });
    const videoInputRef = useRef<HTMLInputElement | null>(null);
    const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);

    const [title1, setTitle1] = useState('');
    const [desc1, setDesc1] = useState('');
    const [moduleDescription, setModuleDescription] = useState('');
    const [moduleLearningObjectives, setModuleLearningObjectives] = useState<string[]>(['']);

    // ------------------------------------------------
    // Lesson-level editing state (curriculum[week].subtopics[i])
    // ------------------------------------------------
    const [activeLessonIndex, setActiveLessonIndex] = useState<number | null>(null);
    const [lessonTitle, setLessonTitle] = useState('');
    const [lessonImage, setLessonImage] = useState<any>();
    const [lessonIntroduction, setLessonIntroduction] = useState('');
    const [lessonCoreInstruction, setLessonCoreInstruction] = useState<Record<string, string>>({});
    const [lessonExample, setLessonExample] = useState('');
    // Structured "examples" array coming from the API (title + content pairs).
    // NOTE: this replaces the old single "example" string field, which is
    // always empty in the API response — the real content lives in "examples".
    const [lessonExamples, setLessonExamples] = useState<{ title: string; content: string }[]>([
        { title: '', content: '' },
    ]);
    // Structured "sections" array coming from the API (heading + content pairs).
    const [lessonSections, setLessonSections] = useState<{ heading: string; content: string }[]>([
        { heading: '', content: '' },
    ]);
    const [lessonKeyTakeaways, setLessonKeyTakeaways] = useState<string[]>(['']);
    const [lessonPracticalApplication, setLessonPracticalApplication] = useState('');
    const [lessonActivityExercise, setLessonActivityExercise] = useState('');
    const [lessonKnowledgeCheck, setLessonKnowledgeCheck] = useState('');
    const [lessonLength, setLessonLength] = useState('');
    const [mainTitle, setMainTitle] = useState('');
    const [coursePrice, setCoursePrice] = useState<any>();
    const [courseDescription, setCourseDescription] = useState<any>();
    const [courseTargetAudi, setCourseTargetAudi] = useState<any>();
    const [learner, setLearner] = useState<any>();
    const [courseDuration, setCourseDuration] = useState<any>();
    const [courseLearningOutcomes, setCourseLearningOutcomes] = useState<any>();
    const [coursePrerequisites, setCoursePrerequisites] = useState<any>('');
    const [showCourseDefinition, setShowCourseDefinition] = useState<boolean>(true);
    const [priceType, setPriceType] = useState<string>("paid");
    const [userDetails, setUserDetails] = useState<any>();
    const [showUnsplash, setShowUnsplash] = useState(false);
    const [unsplashImages, setUnsplashImages] = useState<any[]>([]);
    const [selectedUnsplashImage, setSelectedUnsplashImage] = useState<string>("");
    // const [unsplashSearch, setUnsplashSearch] = useState("online course");
    const useremail = localStorage.getItem('user_email') || '';
    const [choosingImageModal, setChoosingImageModal] = useState<boolean>(false);
    const [deleteVideoModalOpen, setDeleteVideoModalOpen] = useState<boolean>(false);
    const [isDeletingVideo, setIsDeletingVideo] = useState<boolean>(false);
    const [choosingLessonImage, setChoosingLessonImage] = useState<boolean>(false);
    const [openUnsplash, setOpenUnsplash] = useState<any>();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [query, setQuery] = useState('');
    const [images, setImages] = useState<UnsplashImage[]>([]);
    const [unsplashSearch, setUnsplashSearch] = useState<boolean>(false);
    const [selectedUnsplashImg, setSelectedUnsplashImg] = useState(null);
    const [GBAUserLogo, setGBAUserLogo] = useState<any>();


    const [image, setImage] = useState(
        "https://images.unsplash.com/photo-1601582589907-f92af5ed9db8"
    );

    const fileRef = useRef<HTMLInputElement>(null);

    const courseId = location.state?.courseId || null;
    const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
    const hasFetched = useRef(false);

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, false] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
        ],
    };

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };

    const handleItemClick = (itemName: any) => {
        localStorage.setItem('activeItem', itemName);
        localStorage.removeItem('campaignid');
        localStorage.removeItem('returningtocampaign');
        localStorage.removeItem('sourceurl');
        localStorage.removeItem('campaignName');
        localStorage.removeItem('paymentOption');
        localStorage.removeItem('autoPublish');
        localStorage.removeItem('limitPublish');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('addTags');
        localStorage.removeItem('captureLeads');
        localStorage.removeItem('newsLetter');
        localStorage.removeItem('twitterBtn');
        localStorage.removeItem('fbBtn');
        localStorage.removeItem('pintrestBtn');
        localStorage.removeItem('linkedinBtn');
        localStorage.removeItem('video');
        localStorage.removeItem('twitterurl');
        localStorage.removeItem('fburl');
        localStorage.removeItem('pintresturl');
        localStorage.removeItem('linkedinurl');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('owndomain');
        localStorage.removeItem('ChangepayMode');
        localStorage.removeItem('IdChangingMode');
        localStorage.removeItem('PaymentSubscription');
        localStorage.removeItem('Authorurl');
        localStorage.removeItem('Authorname');
        localStorage.removeItem('authorDefaultCheck');
        localStorage.removeItem('videoTag');
        localStorage.removeItem('podcastUrl');
        localStorage.removeItem('sourcetext');
        setActiveItem(localStorage.getItem('activeItem') ? localStorage.getItem('activeItem') : itemName);
        navigate('/codegenie/generated-blogs');
        if (itemName === 'upgrade') {
            const value = {
                _id: "",
                product_name: "CodeGenie",
                product_module: genieSelector.module ? genieSelector.module : "",
                userid: "",
                productid: ""
            };
            getProduct(value);
            localStorage.setItem('fromUpgrade', 'true');
            navigate('/pricing', { state: { campIdFromUpgrade: localStorage.getItem('campId') || ''/* selectedCampaign */, from_page: 'blog_listing' } });
        } else if (itemName === 'logout') {
            clearCookies();
            localStorage.setItem("logged_in", "false");
            //console.log("loggedin:" + localStorage.getItem("logged_in"));
            dispatch(logout());
            var module = localStorage.getItem("module");
            console.log("module111...." + module);

            toast.success("Logout success");
            // localStorage.removeItem("payment");
            localStorage.removeItem("msg");
            localStorage.removeItem("complexity");
            localStorage.removeItem("module");
            localStorage.removeItem("subscription_level");
            localStorage.removeItem("free_plan");
            // localStorage.removeItem("userRole");
            localStorage.removeItem("localStorage_msg");
            localStorage.removeItem("allSet");
            localStorage.removeItem("Blogs Generated");
            localStorage.removeItem("remaining_wish_count");
            localStorage.removeItem("userRole");
            localStorage.removeItem("payment");
            localStorage.removeItem("user_email");
            localStorage.removeItem("logged_in");
            localStorage.removeItem("prevImg");
            localStorage.removeItem("fromUpgrade");
            localStorage.removeItem("blogsCount");
            localStorage.removeItem("Generating Count");
            localStorage.removeItem("finalData");
            localStorage.removeItem("user_pass");
            localStorage.removeItem("fromNewcampaign");
            localStorage.removeItem("campaignid");
            localStorage.removeItem("returningtocampaign");
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('campId');
            localStorage.removeItem('campaignid');
            localStorage.removeItem('returningtocampaign');
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('smUrlpublish');
            localStorage.removeItem('addTags');
            localStorage.removeItem('captureLeads');
            localStorage.removeItem('newsLetter');
            localStorage.removeItem('twitterBtn');
            localStorage.removeItem('fbBtn');
            localStorage.removeItem('pintrestBtn');
            localStorage.removeItem('linkedinBtn');
            localStorage.removeItem('video');
            localStorage.removeItem('twitterurl');
            localStorage.removeItem('fburl');
            localStorage.removeItem('pintresturl');
            localStorage.removeItem('linkedinurl');
            localStorage.removeItem('owndomain');
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
            localStorage.removeItem('user_name');
            localStorage.removeItem('refreshCount');
            localStorage.removeItem('publishingCampId');
            localStorage.removeItem('Authorurl');
            localStorage.removeItem('Authorname');
            localStorage.removeItem('authorDefaultCheck');
            localStorage.removeItem('appsumo_coupon_code');
            localStorage.removeItem('podcastUrl');
            localStorage.removeItem('AlertMessage');
            localStorage.removeItem('CreatingfromLanding');
            localStorage.removeItem('UrlfromLanding');
            localStorage.removeItem('signedup');
            localStorage.removeItem('uploadedvideo');
            localStorage.removeItem('uploadedVideoName');
            localStorage.removeItem('uploadStatus');
            localStorage.removeItem('editedposthashtags');
            localStorage.removeItem('editedpostblogsummary');
            localStorage.removeItem('editedpostblogtitle');
            localStorage.removeItem('editedposturl');
            localStorage.removeItem('user_email');
            localStorage.removeItem('YoutubeUrlfromLanding');
            localStorage.removeItem('FirstLogin');
            localStorage.removeItem('DirectSignup');
            localStorage.removeItem('FromIndexPage');
            localStorage.removeItem('activeItem');
            localStorage.removeItem('UpdateduserImage');
            localStorage.removeItem('FromEditBlog');
            localStorage.removeItem('ErrorAlert');
            localStorage.removeItem('FromSignIn');
            removeCookie('user_email');
            localStorage.clear();

            if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
                navigate("/Anycode_landing");
            else
                redirectAfterLogout(); //"https://ocesha.ai";
        }
    };

    /* const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setImage(URL.createObjectURL(file));
    }; */
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const img = new Image();

        img.onload = () => {
            const ratio = img.width / img.height;
            const expectedRatio = 3 / 2;

            // Allow ~5% tolerance
            if (Math.abs(ratio - expectedRatio) > 0.05) {
                toast.warning(
                    "This image is not in the recommended 3:2 aspect ratio (1080 × 720 px). It can still be uploaded, but it may appear cropped or stretched."
                );
            }


            const previewUrl = URL.createObjectURL(file);

            if (choosingLessonImage) {
                // Lesson-level illustration
                setLessonImage(previewUrl);
                updateActiveLesson({
                    lession_image_file: file,
                    lession_image_preview: previewUrl,
                });
            } else if (showCourseDefinition) {
                // Course-level illustration (used on the Course Definition screen)
                setCourseDefinitionImageFile(file);
                setCourseDefinitionImage(previewUrl);
            } else {
                // Module/week-level illustration
                setSelectedImageFile(file);
                setCourseImage(previewUrl);

                // update only current week
                setCurriculum((prev) => {
                    const copy = [...prev];

                    copy[activeWeekIndex] = {
                        ...copy[activeWeekIndex],
                        chapter_image_file: file,
                        chapter_image_url: previewUrl,
                    };

                    return copy;
                });
            }

            setChoosingLessonImage(false);
            setChoosingImageModal(false)
        }
        img.src = URL.createObjectURL(file);
    };

    useEffect(() => {
        if (!courseId) {
            toast.error('Something went wrong, Please try again later!');
            setLoadingCourse(false);
            return;
        }

        if (hasFetched.current) return;

        hasFetched.current = true;
        getCourseDetail();
    }, [courseId]);

    /* const convertContentToHtml = (content: string) => {
        if (!content) return "";

        // Already HTML from ReactQuill
        if (
            content.includes("<p") ||
            content.includes("<h") ||
            content.includes("<ul") ||
            content.includes("<ol") ||
            content.includes("<strong")
        ) {
            return content;
        }

        // Markdown from backend
        return marked.parse(content) as string;
    }; */
    const convertContentToHtml = (content: string) => {
        if (!content) return "";

        const hasHtml = /<(p|h[1-6]|ul|ol|li|strong|em|u|a|br|blockquote)\b/i.test(
            content
        );

        if (hasHtml) {
            return content;
        }

        return marked.parse(content) as string;
    };

    const normalizePriceType = (value: any) => {
        if (!value) return "paid";

        const type = String(value).toLowerCase();

        if (type === "free" || type === "free_course" || type === "0") {
            return "free";
        }

        return "paid";
    };

    const getCourseDetail = async () => {
        try {
            setLoadingCourse(true);

            // draft=true: show the saved draft if there is one (the live course is untouched)
            const res = await axios.get(`${apiUrl}/api/prompts/get_course/${courseId}?draft=true`);

            console.log('edit course detail response=>', res?.data);
            setCourseHasDraft(!!res?.data?.has_draft);
            setCourseDetails(res?.data?.course);
            const course = res?.data?.course;
            const courseSlug = createCourseSlug(
                course?.title || "",
                course?._id || ""
            );

            const courseShareUrl =
                `${window.location.origin}/course/${courseSlug}`;
            setInstructorDetails(prev => ({
                ...prev,
                profileUrl: course?.social_url || "",
                profileUrl1: courseShareUrl,
                ctaLabel: course?.cta_lable || "", // (API typo handled)
                ctaUrl: course?.cta_url || "",
                introVideoPreview: course?.video_url
                    /* ? `${apiUrl}${course.video_url}`
                    : */ || "",
                existingImageUrl: course?.user?.user_image || "",
                profileImage: course?.user?.user_image
            }));
            const list = res?.data?.course?.curriculum || [];

            setCurriculum(list);
            setMainTitle(res?.data?.course?.title);
            setPriceType(normalizePriceType(res?.data?.course?.price_type));
            setCoursePrice(res?.data?.course?.suggested_price);
            setCourseDescription(res?.data?.course?.description);
            setCourseTargetAudi(res?.data?.course?.target_audience);
            setLearner(res?.data?.course?.difficulty);
            setCourseDuration(res?.data?.course?.course_definition?.total_duration);
            setCoursePrerequisites(res?.data?.course?.course_definition?.prerequisites || '');
            setCourseLearningOutcomes(res?.data?.course?.learning_outcomes);
            console.log('main title res =>', res?.data?.course?.title);
            setActiveWeekIndex(0);
            setCourseDefinitionImage(res?.data?.course?.image_path || '');
            // setCourseImage(res?.data?.course?.image_path_small);

            if (list.length > 0) {
                setTitle1(list[0].title || '');
                // setDesc1((list[0].content).replace(/[*#]+/g, "") || '');
                setDesc1(convertContentToHtml(list[0].content || ''));
                setModuleDescription(list[0]?.module_objective || '');
                setCourseImage(list[0]?.chapter_image || '');
                setModuleLearningObjectives(
                    Array.isArray(list[0]?.module_learning_objectives) && list[0].module_learning_objectives.length > 0
                        ? list[0].module_learning_objectives
                        : ['']
                );
            }
            /* if (list.length > 0) {
                setTitle1(list[0].title || '');
                setDesc1(list[0].content || '');
            } */
        } catch (error: any) {
            console.log('Error fetching course detail=>', error);
            toast.error(error);
        } finally {
            setLoadingCourse(false);
        }
    };

    useEffect(() => {
        return () => {
            if (instructorDetails.profileImagePreview) {
                URL.revokeObjectURL(instructorDetails.profileImagePreview);
            }
        };
    }, [instructorDetails.profileImagePreview]);

    const uploadInstructorProfileImage = async () => {
        if (!instructorDetails.profileImage) return;
        try {
            const imgFormData = new FormData();
            imgFormData.append('first_name', userDetails?.first_name || '');
            imgFormData.append('last_name', userDetails?.last_name || '');
            imgFormData.append('email', useremail);
            imgFormData.append('user_image', instructorDetails.profileImage);

            const imgRes = await axios.post(apiUrl + '/api/auth/updateUserSettings', imgFormData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (imgRes.data.user_image) {
                const newImg = imgRes.data.user_image + '?' + Math.random();
                setInstructorDetails(prev => ({ ...prev, existingImageUrl: newImg }));
                localStorage.setItem('UpdateduserImage', newImg);
                await fetchData();
                window.dispatchEvent(new Event("profileUpdated"));
                // window.dispatchEvent(new Event('storage'));
            }
        } catch (err) {
            console.error('Instructor image upload error:', err);
            toast.error('Failed to update profile image');
        }
    };

    const videoSrc = instructorDetails.introVideo
        ? instructorDetails.introVideoPreview // blob
        : instructorDetails.introVideoPreview
            ? `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${instructorDetails.introVideoPreview}`
            : "";

    useEffect(() => {
        if (!curriculum.length) return;

        const current = curriculum[activeWeekIndex];

        setTitle1(current?.title || '');
        // setDesc1((current?.content).replace(/[*#]+/g, "") || '');
        setDesc1(convertContentToHtml(current?.content || ''));
        setModuleDescription(current?.module_objective || '');
        console.log('course details=>', current?.content);
        // setDesc1(current?.content || '');

        // weekwise image
        // setCourseImage(current?.chapter_image_url || current?.chapter_image || '');
        setCourseImage(
            current?.chapter_image_preview ||
            current?.chapter_image_url ||
            current?.chapter_image ||
            ''
        );

        setModuleLearningObjectives(
            Array.isArray(current?.module_learning_objectives) && current.module_learning_objectives.length > 0
                ? current.module_learning_objectives
                : ['']
        );

    }, [activeWeekIndex/* , curriculum */]);

    // ------------------------------------------------
    // Module Learning Objectives handlers
    // ------------------------------------------------
    const handleObjectiveChange = (index: number, value: string) => {
        setModuleLearningObjectives((prev) => {
            const updated = [...prev];
            updated[index] = value;

            setCurriculum((prevCurriculum) => {
                const copy = [...prevCurriculum];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    module_learning_objectives: updated,
                };

                return copy;
            });

            return updated;
        });
    };

    const handleAddObjective = () => {
        setModuleLearningObjectives((prev) => {
            const updated = [...prev, ''];

            setCurriculum((prevCurriculum) => {
                const copy = [...prevCurriculum];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    module_learning_objectives: updated,
                };

                return copy;
            });

            return updated;
        });
    };

    const handleRemoveObjective = (index: number) => {
        setModuleLearningObjectives((prev) => {
            const updated = prev.filter((_, i) => i !== index);
            const finalUpdated = updated.length > 0 ? updated : [''];

            setCurriculum((prevCurriculum) => {
                const copy = [...prevCurriculum];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    module_learning_objectives: finalUpdated,
                };

                return copy;
            });

            return finalUpdated;
        });
    };

    // ------------------------------------------------
    // Sync lesson-level fields whenever the selected lesson changes
    // ------------------------------------------------
    useEffect(() => {
        if (activeLessonIndex === null) return;

        const lesson = curriculum[activeWeekIndex]?.subtopics?.[activeLessonIndex];

        if (!lesson) return;

        setLessonTitle(lesson?.lesson_title || '');
        setLessonImage(
            lesson?.lession_image_preview ||
            lesson?.lession_image ||
            ''
        );
        setLessonIntroduction(convertContentToHtml(lesson?.introduction || ''));
        setLessonCoreInstruction(
            lesson?.core_instruction && typeof lesson.core_instruction === 'object'
                ? lesson.core_instruction
                : {}
        );
        setLessonExample(lesson?.example || '');
        setLessonExamples(
            Array.isArray(lesson?.examples) && lesson.examples.length > 0
                ? lesson.examples.map((ex: any) => ({
                      title: ex?.title || '',
                      content: ex?.content || '',
                  }))
                : [{ title: '', content: '' }]
        );
        setLessonSections(
            Array.isArray(lesson?.sections) && lesson.sections.length > 0
                ? lesson.sections.map((sec: any) => ({
                      heading: sec?.heading || '',
                      content: sec?.content || '',
                  }))
                : [{ heading: '', content: '' }]
        );
        setLessonKeyTakeaways(
            Array.isArray(lesson?.key_takeaways) && lesson.key_takeaways.length > 0
                ? lesson.key_takeaways
                : ['']
        );
        setLessonPracticalApplication(lesson?.practical_application || '');
        setLessonActivityExercise(lesson?.activity_exercise || '');
        setLessonKnowledgeCheck(lesson?.knowledge_check || '');
        setLessonLength(lesson?.lesson_length || '');
    }, [activeWeekIndex, activeLessonIndex]);

    // ------------------------------------------------
    // Lesson-level field handlers
    // ------------------------------------------------
    const updateActiveLesson = (fields: Record<string, any>) => {
        if (activeLessonIndex === null) return;

        setCurriculum((prev) => {
            const copy = [...prev];
            const week = { ...copy[activeWeekIndex] };
            const subtopics = Array.isArray(week.subtopics) ? [...week.subtopics] : [];

            subtopics[activeLessonIndex] = {
                ...subtopics[activeLessonIndex],
                ...fields,
            };

            week.subtopics = subtopics;
            copy[activeWeekIndex] = week;

            return copy;
        });
    };

    const handleLessonTitleChange = (value: string) => {
        setLessonTitle(value);
        updateActiveLesson({ lesson_title: value });
    };

    const handleLessonIntroductionChange = (value: string) => {
        setLessonIntroduction(value);
        updateActiveLesson({ introduction: value });
    };

    const handleLessonExampleChange = (value: string) => {
        setLessonExample(value);
        updateActiveLesson({ example: value });
    };

    // ------------------------------------------------
    // Lesson "examples" (array) handlers
    // ------------------------------------------------
    const handleLessonExampleFieldChange = (
        index: number,
        field: "title" | "content",
        value: string
    ) => {
        setLessonExamples((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            updateActiveLesson({ examples: updated });
            return updated;
        });
    };

    const handleAddLessonExample = () => {
        setLessonExamples((prev) => {
            const updated = [...prev, { title: '', content: '' }];
            updateActiveLesson({ examples: updated });
            return updated;
        });
    };

    const handleRemoveLessonExample = (index: number) => {
        setLessonExamples((prev) => {
            const updated = prev.filter((_, i) => i !== index);
            const finalUpdated = updated.length > 0 ? updated : [{ title: '', content: '' }];
            updateActiveLesson({ examples: finalUpdated });
            return finalUpdated;
        });
    };

    // ------------------------------------------------
    // Lesson "sections" (array) handlers
    // ------------------------------------------------
    const handleLessonSectionFieldChange = (
        index: number,
        field: "heading" | "content",
        value: string
    ) => {
        setLessonSections((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            updateActiveLesson({ sections: updated });
            return updated;
        });
    };

    const handleAddLessonSection = () => {
        setLessonSections((prev) => {
            const updated = [...prev, { heading: '', content: '' }];
            updateActiveLesson({ sections: updated });
            return updated;
        });
    };

    const handleRemoveLessonSection = (index: number) => {
        setLessonSections((prev) => {
            const updated = prev.filter((_, i) => i !== index);
            const finalUpdated = updated.length > 0 ? updated : [{ heading: '', content: '' }];
            updateActiveLesson({ sections: finalUpdated });
            return finalUpdated;
        });
    };

    const handleLessonPracticalApplicationChange = (value: string) => {
        setLessonPracticalApplication(value);
        updateActiveLesson({ practical_application: value });
    };

    const handleLessonActivityExerciseChange = (value: string) => {
        setLessonActivityExercise(value);
        updateActiveLesson({ activity_exercise: value });
    };

    const handleLessonKnowledgeCheckChange = (value: string) => {
        setLessonKnowledgeCheck(value);
        updateActiveLesson({ knowledge_check: value });
    };

    const handleLessonLengthChange = (value: string) => {
        setLessonLength(value);
        updateActiveLesson({ lesson_length: value });
    };

    const handleLessonCoreInstructionChange = (key: string, value: string) => {
        setLessonCoreInstruction((prev) => {
            const updated = { ...prev, [key]: value };
            updateActiveLesson({ core_instruction: updated });
            return updated;
        });
    };

    const handleLessonKeyTakeawayChange = (index: number, value: string) => {
        setLessonKeyTakeaways((prev) => {
            const updated = [...prev];
            updated[index] = value;
            updateActiveLesson({ key_takeaways: updated });
            return updated;
        });
    };

    const handleAddLessonKeyTakeaway = () => {
        setLessonKeyTakeaways((prev) => {
            const updated = [...prev, ''];
            updateActiveLesson({ key_takeaways: updated });
            return updated;
        });
    };

    const handleRemoveLessonKeyTakeaway = (index: number) => {
        setLessonKeyTakeaways((prev) => {
            const updated = prev.filter((_, i) => i !== index);
            const finalUpdated = updated.length > 0 ? updated : [''];
            updateActiveLesson({ key_takeaways: finalUpdated });
            return finalUpdated;
        });
    };

    const handleInstructorChange = (field: string, value: any) => {
        setInstructorDetails(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleVideoUpload = (file: File | null) => {
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);

        setInstructorDetails(prev => ({
            ...prev,
            introVideo: file,
            introVideoPreview: previewUrl,
            removeVideo: false,
        }));
    };

    const handleRemoveVideo = () => {
        // Release the blob URL for any freshly-selected (not yet saved) video
        if (instructorDetails.introVideo && instructorDetails.introVideoPreview) {
            URL.revokeObjectURL(instructorDetails.introVideoPreview);
        }

        setInstructorDetails(prev => ({
            ...prev,
            introVideo: null,
            introVideoPreview: "",
            // Tell the save handler an existing (already-saved) video should
            // be deleted on the server too.
            removeVideo: true,
        }));

        // Reset the file input so selecting the same file again re-triggers onChange
        if (videoInputRef.current) {
            videoInputRef.current.value = "";
        }
    };

    // Called when the user confirms deletion in the "Delete intro video?" dialog.
    const handleConfirmDeleteVideo = async () => {
        // A freshly-picked file that hasn't been saved yet only lives in the
        // browser (blob URL) — there's nothing on the server to delete, so
        // just clear it locally.
        if (instructorDetails.introVideo) {
            handleRemoveVideo();
            setDeleteVideoModalOpen(false);
            return;
        }

        if (!courseId) {
            setDeleteVideoModalOpen(false);
            return;
        }

        setIsDeletingVideo(true);
        try {
            await axios.put(`${apiUrl}/api/prompts/delete_intro_video/${courseId}?draft=true`);
            handleRemoveVideo();
            toast.success("Intro video deleted");
            setDeleteVideoModalOpen(false);
        } catch (err: any) {
            toast.error("Failed to delete intro video");
        } finally {
            setIsDeletingVideo(false);
        }
    };

    const handleImageUpload = (file: File | null) => {
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);

        setInstructorDetails(prev => ({
            ...prev,
            profileImage: file,
            profileImagePreview: previewUrl
        }));
    };

    // updating course details
    const handleUpdateCourse = async () => {
        setUpdatingCourseDet(true);
        let savedAsDraft = false;   // set when the server stored the changes as a draft (course is live)
        try {
            // ---------------
            // 1. Update Course Basic
            // ---------------
            try {
                // const payload = new URLSearchParams();
                const payload = new FormData();

                payload.append("title", mainTitle);
                payload.append("name", courseDetails.name);
                payload.append("description", courseDescription);
                payload.append("difficulty", learner);
                payload.append("target_audience", courseTargetAudi);
                payload.append("suggested_price", coursePrice);
                payload.append("duration", courseDuration);
                payload.append("prerequisites", coursePrerequisites);
                payload.append("price_type", priceType); /* new */

                payload.append("social_url", instructorDetails.profileUrl);
                payload.append("cta_lable", instructorDetails.ctaLabel);
                payload.append("cta_url", instructorDetails.ctaUrl);

                if (instructorDetails.introVideo) {
                    payload.append("video_file", instructorDetails.introVideo);
                } else if (instructorDetails.removeVideo) {
                    // No new file selected, but the existing video was deleted —
                    // tell the backend to clear it. Confirm this field name
                    // matches what the update-course API expects.
                    payload.append("remove_video", "true");
                }

                // Course definition illustration image (from local upload or
                // Unsplash, see handleImageChange / handleSelectUnsplashImage)
                if (courseDefinitionImageFile) {
                    payload.append("image_file", courseDefinitionImageFile);
                }

                /* if (instructorDetails.profileImage) {
                    payload.append("profile_image", instructorDetails.profileImage);
                } */

                const res = await axios.put(`${apiUrl}/api/prompts/update_course_basic/${courseId}?draft=true`,
                    payload,
                    {
                        headers: {
                            "content-type": "application/x-www-form-urlencoded"
                        }
                    });

                if (res?.data?.saved_as === "draft") savedAsDraft = true;

                await uploadInstructorProfileImage();
            } catch (err: any) {
                toast.error("Failed to update course basic details");
                return;
            }

            // ------------
            // 2. Update Learning Outcomes
            // ------------
            try {
                const loPayload = new URLSearchParams();

                loPayload.append(
                    "learning_outcomes",
                    JSON.stringify(courseLearningOutcomes)
                );

                const loRes = await axios.put(
                    `${apiUrl}/api/prompts/update_learning_outcomes/${courseId}?draft=true`,
                    loPayload,
                    {
                        headers: {
                            "content-type": "application/x-www-form-urlencoded"
                        }
                    }
                );
                if (loRes?.data?.saved_as === "draft") savedAsDraft = true;
            } catch (err: any) {
                toast.error("Failed to update learning outcomes");
                return;
            }

            // -------------------------
            // 3. Update all weeks in loop
            // -------------------------
            for (const weekItem of curriculum) {
                try {
                    const formData = new FormData();

                    formData.append("title", weekItem.title);
                    formData.append("content", weekItem.content);
                    formData.append("module_objective", weekItem.module_objective || "");
                    formData.append(
                        "learning_objectives",
                        JSON.stringify(weekItem.module_learning_objectives || [])
                    );

                    // Module/week illustration
                    if (weekItem.chapter_image_file) {
                        formData.append("chapter_image", weekItem.chapter_image_file);
                    } else {
                        formData.append("chapter_image_url", weekItem.chapter_image_url || "");
                    }

                    // Lesson illustrations: a File can't survive JSON.stringify
                    // (it serializes to "{}"), so pull each lesson's file out
                    // of the JSON blob and send it as its own multipart field,
                    // keyed by lesson index, alongside the JSON minus the file.
                    const subtopics = Array.isArray(weekItem.subtopics) ? weekItem.subtopics : [];

                    const subtopicsForJson = subtopics.map((lesson: any, idx: number) => {
                        const { lession_image_file, ...lessonRest } = lesson || {};

                        if (lession_image_file) {
                            formData.append(`lesson_image_${idx}`, lession_image_file);
                        }

                        return lessonRest;
                    });

                    formData.append("subtopics", JSON.stringify(subtopicsForJson));

                    const weekRes = await axios.put(
                        `${apiUrl}/api/prompts/update_week/${courseId}/${weekItem.week}?draft=true`,
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    );
                    if (weekRes?.data?.saved_as === "draft") savedAsDraft = true;
                } catch (err: any) {
                    toast.error(`Failed to update week ${weekItem.week}`);
                    return;
                }
            }

            toast.success(
                savedAsDraft
                    ? "Draft saved — your live course is unchanged. Publish the course to make these changes live."
                    : "Course updated successfully"
            );
            getCourseDetail();
        } catch (error: any) {
            console.log('Error updating course details=>', error);
        } finally {
            setUpdatingCourseDet(false);
        }
    };

    const openUnsplashPicker = async (query: string) => {
        try {
            setShowUnsplash(true);

            const res = await axios.get(
                "https://api.unsplash.com/search/photos",
                {
                    params: {
                        query,
                        per_page: 20
                    },
                    headers: {
                        Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
                    }
                }
            );

            setUnsplashImages(res.data.results);

        } catch (err) {
            toast.error("Failed to load Unsplash images");
        }
    };

    /* const handleSelectUnsplashImage = (img: any) => {

        // show selected image in main preview
        setCourseImage(img.urls.regular);

        // store chosen path for API usage later
        setSelectedUnsplashImage(img.urls.raw);

        setShowUnsplash(false);

    }; */
    /* const handleSelectUnsplashImage = (img: any) => {

        // preview for current UI
        setCourseImage(img.urls.regular);

        // update only active week
        setCurriculum((prev) => {
            const copy = [...prev];

            copy[activeWeekIndex] = {
                ...copy[activeWeekIndex],

                // overwrite only this week's image
                chapter_image_url: img.urls.raw,

                // optional preview
                chapter_image_preview: img.urls.regular,
            };

            return copy;
        });

        setShowUnsplash(false);
    }; */

    const handleSelectUnsplashImage = async (imageUrl: any, imageid: any) => {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const file = new File([blob], "unsplash_image.jpg", { type: blob.type });

        if (choosingLessonImage) {
            // Lesson-level illustration -> goes out later via update_week
            setLessonImage(imageUrl);
            updateActiveLesson({
                lession_image_file: file,
                lession_image_preview: imageUrl,
            });
        } else if (showCourseDefinition) {
            // Course-level illustration (Course Definition screen) -> goes
            // out later via update_course_basic
            setCourseDefinitionImageFile(file);
            setCourseDefinitionImage(imageUrl);
        } else {
            // Module/week-level illustration -> goes out later via
            // update_week
            setCourseImage(imageUrl);

            setCurriculum((prev) => {
                const copy = [...prev];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    chapter_image_preview: imageUrl,
                    chapter_image_url: imageUrl,
                    chapter_image_file: file,
                };

                return copy;
            });
        }

        setShowUnsplash(false);
    };

    const fetchData = async () => {
        try {

            const response = await getUserDetailsMutation({ email: useremail, filter: '', start_date: '', end_date: '' });

            if ('data' in response) {
                const details = response.data.data;
                setUserDetails(details);
                console.log('userdetails from edit course=>', details);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleImageClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleSearch = async () => {
        setUnsplashSearch(true);
        if (!query) {
            toast.error('Please enter any value to search');
        } else {
            try {
                // const response = await axios.get(`https://api.unsplash.com/search/photos`, {
                const response = await axios.get(
                    "https://api.unsplash.com/search/photos",
                    {
                        params: {
                            query,
                            per_page: 20
                        },
                        headers: {
                            Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
                        }
                    }
                );
                setImages(response.data.results);
            } catch (error) {
                console.error("Error fetching images from Unsplash", error);
            }
        }
    };

    const horizontalImages = images.filter(image => image.width > image.height);

    const modifyImageUrl = (url: any) => {
        let modifiedUrl = new URL(url);

        modifiedUrl.searchParams.set('fit', 'none');

        modifiedUrl.searchParams.set('w', '1152');

        modifiedUrl.searchParams.set('h', '500');

        return modifiedUrl.toString();
    };

    const handleUnsplashselectionChange = () => {
        const hasSelection = choosingLessonImage
            ? !!lessonImage
            : showCourseDefinition
                ? !!courseDefinitionImage
                : !!courseImage;

        if (!hasSelection) {
            toast.error('Please select any image!');
        } else {
            setChoosingLessonImage(false);
            setOpenUnsplash(false);
            setChoosingImageModal(false);
        }
    };

    const getPartnerDetails = async () => {
        try {

            const response = await axios.get(
                `${apiUrl}/api/users/partners/details`,
                {
                    params: {
                        partner_name: (localStorage.getItem("partner_name") ||
                            userDetails?.partner),
                    },
                }
            );

            if (
                response.data?.status === "success" &&
                response.data?.data
            ) {
                const data = response.data.data;
                setGBAUserLogo(data.logo_url);
            }
        } catch (err) {
            console.log("Partner details not found", err);
        }
    };

    useEffect(() => {
        if ((localStorage.getItem("partner_name") /* === "GPA" */ || userDetails?.partner /* === "GPA" */)) {
            getPartnerDetails();
        }
    }, []);

    useEffect(() => {
        const handler = (e: any) => {
            setGBAUserLogo(e.detail.logo);
        };

        window.addEventListener("partner-logo-updated", handler);

        return () => {
            window.removeEventListener("partner-logo-updated", handler);
        };
    }, []);

    // Values used by the course-structure header and breadcrumb navigation.
    const displayedCourseTitle = mainTitle || courseDetails?.title || "Course";
    const totalLessons = curriculum.reduce(
        (sum, moduleItem) =>
            sum + (Array.isArray(moduleItem?.subtopics) ? moduleItem.subtopics.length : 0),
        0
    );
    const activeModuleNumber = activeWeekIndex + 1;
    const activeLesson =
        activeLessonIndex !== null
            ? curriculum[activeWeekIndex]?.subtopics?.[activeLessonIndex]
            : null;
    const displayedLessonTitle =
        activeLesson?.lesson_title ||
        activeLesson?.title ||
        (activeLessonIndex !== null ? `Lesson ${activeLessonIndex + 1}` : "");

    return (
        <>
            {/* Constrain the height of the ReactQuill editors used for
                Module Description / Lesson Introduction so they don't take
                up so much vertical space. ".curriculum-quill" keeps the
                original (uncapped) behaviour for any other usage; add the
                "curriculum-quill--compact" class (already done above) to
                opt an editor into the shorter height. */}
            <GlobalStyles
                styles={{
                    ".curriculum-quill--compact .ql-container": {
                        minHeight: 90,
                        maxHeight: 160,
                        overflowY: "auto",
                    },
                    ".curriculum-quill--compact .ql-editor": {
                        paddingRight: 30,
                    },
                }}
            />
            {loadingCourse && (
                <Box
                    sx={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 2000,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2,
                        background: '#020617',
                    }}
                >
                    <CircularProgress size={48} sx={{ color: '#4BA5EB' }} />
                    <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>
                        Loading course content...
                    </Typography>
                </Box>
            )}
            {/* <Header /> */}
            <div style={{ overflowX: 'hidden' }}>
                <div className="row">
                    {/* header */}
                    <div className="row" style={{ marginTop: '1%' }}>
                        {/* <div className="col-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
                            <img src={oceshaLogo} alt="" style={{ width: '30%' }} />
                            {(localStorage.getItem('partner_name') === 'GPA' || userDetails?.partner === 'GPA') && (<img src={GBALogo} alt="" style={{ width: '30%' }} />)}
                            
                        </div> */}
                        <div
                            className="col-3"
                            style={{
                                display: "flex",
                                justifyContent: (oceshaLogo && GBAUserLogo) ? "center" : "",
                                alignItems: "center",
                                gap: "12px",
                            }}
                        >
                            <img
                                src={oceshaLogo}
                                alt="Ocesha Logo"
                                style={{
                                    width: "60px",
                                    height: "auto",
                                }}
                            />

                            {((localStorage.getItem("partner_name") /* === "GPA" */ ||
                                userDetails?.partner /* === "GPA" */) && GBAUserLogo) && (
                                    <img
                                        src={GBAUserLogo}
                                        alt="GBA Logo"
                                        style={{
                                            width: "200px",
                                            height: "100px",
                                            objectFit: "contain",
                                        }}
                                    />
                                )}
                        </div>
                        {/* <Tooltip title="Click here for help video">
                                <img src={youtubeIco1} style={{ cursor: 'pointer', height: '40px', marginTop: '-9px', marginLeft: '-9px' }}
                                    onClick={() => {
                                        setHelperVideoSrc("/images/Overview.mp4");
                                        setHelperPopup(true);
                                    }} />
                            </Tooltip> */}
                        <div className="col-9" style={{ display: 'flex', justifyContent: 'flex-end', gap: '1px' }}>
                            <Ocesha_header handleItemClick={handleItemClick} />
                        </div>
                    </div>
                    <Divider sx={{ mt: 2 }} />
                    {/* <hr /> */}
                    {/* end header */}
                    <div className="overlay-container">
                        <Box
                            sx={{
                                minHeight: "100vh",
                                p: { xs: 2, md: 4 },
                                // background: '#fff'
                                /* background:
                                  "radial-gradient(120% 120% at 50% 0%, rgba(139,92,246,0.12), #020617 60%)", */
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* Left */}
                                <Typography sx={{ color: /* "#000" */"#fff", fontWeight: 600, fontSize: '26px' }}>
                                    Edit Course
                                </Typography>

                                {/* Right */}
                                <Stack direction="row" spacing={2} mb={2}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            textTransform: "none",
                                            background: "#fff",
                                            color: "#000",
                                            display: 'flex',
                                            gap: 1,
                                            alignItems: 'center',
                                            "&:hover": { background: '#fff', color: '#000' }
                                        }}
                                        onClick={() => navigate('/codegenie/generated-blogs')

                                        }
                                    >
                                        <WestIcon />Back to courses list
                                    </Button>

                                    <Button
                                        variant="contained"
                                        sx={{
                                            textTransform: "none",
                                            background: "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                            borderRadius: "50px",
                                            color: '#fff'
                                        }}
                                        onClick={handleUpdateCourse}
                                    >
                                        {updatingCourseDet ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : "Save Changes"}
                                    </Button>
                                </Stack>
                            </Box>
                            <Divider />

                            {courseHasDraft && (
                                <Box
                                    sx={{
                                        display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap",
                                        mt: 2, mb: 2, px: 2, py: 1.25, borderRadius: "10px",
                                        background: "rgba(75,165,235,0.1)", border: "1px solid rgba(75,165,235,0.35)",
                                    }}
                                >
                                    <Typography sx={{ color: "#7fc2f5", fontSize: 13.5 }}>
                                        📝 You're editing a draft. Your changes are saved but not live yet — the published course is unchanged until you publish it.
                                    </Typography>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        sx={{ textTransform: "none", color: "#7fc2f5", borderColor: "rgba(75,165,235,0.5)" }}
                                        onClick={() =>
                                            window.open(
                                                `${window.location.origin}/course/${createCourseSlug(courseDetails?.title || "", courseDetails?._id || courseId || "")}`,
                                                "_blank"
                                            )
                                        }
                                    >
                                        View live version
                                    </Button>
                                </Box>
                            )}

                            {/* Parent container for breadcrumb + editor panels */}
                            <Paper
                                sx={{
                                    background: "#fff",
                                    p: { xs: 1, md: 2 },
                                    borderRadius: "12px",
                                    border: "1px solid #E5E7EB",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                }}
                            >
                                <Grid container spacing={3} alignItems="stretch">
                                    {/* MODULES & LESSONS SIDEBAR */}
                                    <Grid item xs={12} md={2.5} sx={{ display: "flex" }}>
                                        <Paper
                                            sx={{
                                                p: 0,
                                                borderRadius: 2,
                                                background: "transparent",
                                                border: "1px solid #E5E7EB",
                                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                maxHeight: { xs: 480, md: 720 },
                                            }}
                                        >
                                            <Box sx={{ px: 2, pt: 2, pb: 1.5 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "15px",
                                                        fontWeight: 600,
                                                        color: "#000",
                                                        mb: 1.25,
                                                    }}
                                                >
                                                    Course Structure
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        border: "1px solid #E5E7EB",
                                                        borderRadius: "8px",
                                                        px: 1.2,
                                                        py: 1.1,
                                                        backgroundColor: "#FFFFFF",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "12px",
                                                            fontWeight: 600,
                                                            color: "#111827",
                                                            lineHeight: 1.4,
                                                        }}
                                                    >
                                                        {displayedCourseTitle}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "10.5px",
                                                            fontWeight: 400,
                                                            color: "#6B7280",
                                                            lineHeight: 1.5,
                                                            mt: 0.45,
                                                        }}
                                                    >
                                                        {curriculum.length} {curriculum.length === 1 ? "Module" : "Modules"}
                                                        <Box component="span" sx={{ mx: 0.7 }}>•</Box>
                                                        {totalLessons} {totalLessons === 1 ? "Lesson" : "Lessons"}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    minHeight: 0,
                                                    overflowY: "auto",
                                                    px: 1,
                                                    pb: 2,

                                                    "&::-webkit-scrollbar": { width: "5px" },
                                                    "&::-webkit-scrollbar-track": { background: "transparent" },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        background: "rgba(0,0,0,0.18)",
                                                        borderRadius: "10px",
                                                    },
                                                }}
                                            >
                                                <Stack spacing={0}>
                                                    {/* Course Definition */}
                                                    <Box
                                                        sx={{
                                                            position: "relative",
                                                            mb: 1,
                                                            borderLeft: showCourseDefinition
                                                                ? "2px solid #2563EB"
                                                                : "2px solid transparent",
                                                            backgroundColor: showCourseDefinition ? "#F3F8FF" : "transparent",
                                                            borderRadius: "0 6px 6px 0",
                                                            transition: "all 0.2s ease",
                                                            "&:hover": {
                                                                backgroundColor: showCourseDefinition ? "#F3F8FF" : "#FAFAFA",
                                                            },
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{ px: 1.2, py: 1.2, cursor: "pointer" }}
                                                            onClick={() => {
                                                                setShowCourseDefinition(true);
                                                                setActiveLessonIndex(null);
                                                            }}
                                                        >
                                                            <Stack direction="row" alignItems="flex-start" sx={{ width: "100%" }}>
                                                                <MenuBookOutlinedIcon
                                                                    sx={{
                                                                        fontSize: 22,
                                                                        color: showCourseDefinition ? "#2563EB" : "#6B7280",
                                                                        mr: 1.2,
                                                                        flexShrink: 0,
                                                                    }}
                                                                />

                                                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: "12px",
                                                                            fontWeight: showCourseDefinition ? 600 : 500,
                                                                            color: showCourseDefinition ? "#2563EB" : "#111827",
                                                                            lineHeight: 1.3,
                                                                            mb: 0.35,
                                                                        }}
                                                                    >
                                                                        Course Definition
                                                                    </Typography>

                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: "10.5px",
                                                                            fontWeight: 400,
                                                                            color: "#6B7280",
                                                                            lineHeight: 1.4,
                                                                        }}
                                                                    >
                                                                        Overview, audience & objectives
                                                                    </Typography>
                                                                </Box>

                                                                <ChevronRightIcon
                                                                    sx={{
                                                                        fontSize: 20,
                                                                        color: showCourseDefinition ? "#2563EB" : "#6B7280",
                                                                        ml: 1,
                                                                        flexShrink: 0,
                                                                    }}
                                                                />
                                                            </Stack>
                                                        </Box>
                                                    </Box>

                                                    {curriculum.map((weekItem, wIndex) => {
                                                        const isActive = wIndex === activeWeekIndex && !showCourseDefinition;
                                                        const isExpanded = expandedWeeks.includes(wIndex);

                                                        return (
                                                            <Box
                                                                key={weekItem.week ?? wIndex}
                                                                sx={{
                                                                    borderLeft: isActive
                                                                        ? "2px solid #2563EB"
                                                                        : "2px solid transparent",
                                                                    backgroundColor: isActive
                                                                        ? "#F3F8FF"
                                                                        : "transparent",
                                                                    borderRadius: "0 6px 6px 0",
                                                                    transition: "all 0.2s ease",
                                                                    "&:hover": {
                                                                        backgroundColor: isActive
                                                                            ? "#F3F8FF"
                                                                            : "#FAFAFA",
                                                                    },
                                                                }}
                                                            >
                                                                {/* Module Header */}
                                                                <Box
                                                                    sx={{ px: 1.2, py: 1.4, cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        setActiveWeekIndex(wIndex);
                                                                        setActiveLessonIndex(null);
                                                                        setShowCourseDefinition(false);

                                                                        setExpandedWeeks((prev) =>
                                                                            prev.includes(wIndex)
                                                                                ? prev.filter((i) => i !== wIndex)
                                                                                : [wIndex]
                                                                        );
                                                                    }}
                                                                >
                                                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                                                        {/* Module Number */}
                                                                        <Box
                                                                            sx={{
                                                                                width: 20,
                                                                                height: 20,
                                                                                minWidth: 20,
                                                                                borderRadius: "50%",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                mt: "1px",
                                                                                border: isActive ? "none" : "1px solid #6B7280",
                                                                                backgroundColor: isActive ? "#2563EB" : "#FFFFFF",
                                                                                color: isActive ? "#FFFFFF" : "#374151",
                                                                                fontSize: "11px",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {wIndex + 1}
                                                                        </Box>

                                                                        {/* Module Content */}
                                                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                            <Stack
                                                                                direction="row"
                                                                                alignItems="flex-start"
                                                                                justifyContent="space-between"
                                                                                spacing={0.5}
                                                                            >
                                                                                <Typography
                                                                                    sx={{
                                                                                        fontSize: "12px",
                                                                                        lineHeight: 1.45,
                                                                                        fontWeight: isActive ? 600 : 500,
                                                                                        color: isActive ? "#2563EB" : "#111827",
                                                                                        pr: 0.5,
                                                                                        textAlign: "left",
                                                                                    }}
                                                                                >
                                                                                    Module {weekItem.week ?? wIndex + 1}
                                                                                    <br />
                                                                                    {weekItem.title?.replace(/\bweeks?\b/i, "Module")}
                                                                                </Typography>

                                                                                {/* Chevron */}
                                                                                {isExpanded ? (
                                                                                    <KeyboardArrowUpIcon
                                                                                        sx={{
                                                                                            fontSize: 18,
                                                                                            color: isActive ? "#2563EB" : "#6B7280",
                                                                                            flexShrink: 0,
                                                                                            mt: "1px",
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <KeyboardArrowDownIcon
                                                                                        sx={{
                                                                                            fontSize: 18,
                                                                                            color: isActive ? "#2563EB" : "#6B7280",
                                                                                            flexShrink: 0,
                                                                                            mt: "1px",
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </Stack>
                                                                        </Box>
                                                                    </Stack>
                                                                </Box>

                                                                {/* Lessons */}
                                                                {isExpanded && (
                                                                    <Stack
                                                                        spacing={0.8}
                                                                        sx={{ pl: 5.2, pr: 1.5, pb: 1.5 }}
                                                                    >
                                                                        {weekItem.subtopics?.map((sub: any, i: number) => {
                                                                            const lessonTitle =
                                                                                sub?.lesson_title?.replace(/\bweeks?\b/gi, "Module") ||
                                                                                sub?.title ||
                                                                                `Lesson ${i + 1}`;

                                                                            const isActiveLesson =
                                                                                isActive && activeLessonIndex === i;

                                                                            return (
                                                                                <Typography
                                                                                    key={i}
                                                                                    sx={{
                                                                                        fontSize: "11px",
                                                                                        lineHeight: 1.4,
                                                                                        color: isActiveLesson ? "#2563EB" : "#4B5563",
                                                                                        fontWeight: isActiveLesson ? 600 : 400,
                                                                                        cursor: "pointer",
                                                                                        "&:hover": { color: "#2563EB" },
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setActiveWeekIndex(wIndex);
                                                                                        setActiveLessonIndex(i);
                                                                                        setShowCourseDefinition(false);
                                                                                    }}
                                                                                >
                                                                                    • {lessonTitle}
                                                                                </Typography>
                                                                            );
                                                                        })}
                                                                    </Stack>
                                                                )}
                                                            </Box>
                                                        );
                                                    })}
                                                </Stack>
                                            </Box>
                                        </Paper>
                                    </Grid>

                                    {/* LEFT + RIGHT PANELS */}
                                    <Grid item xs={12} md={9.5}>
                                        <Paper
                                            sx={{
                                                p: { xs: 1, md: 2 },
                                                borderRadius: "12px",
                                                background: "#fff",
                                                border: "1px solid #E5E7EB",
                                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                                width: "100%",
                                            }}
                                        >
                                            {/* Breadcrumb navigation */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: 0.8,
                                        px: 0.5,
                                        pt: 0.5,
                                        pb: 1.5,
                                    }}
                                >
                                    <MenuBookOutlinedIcon sx={{ fontSize: 17, color: "#1F3B78" }} />
                                    <Typography sx={{ fontSize: 11.5, fontWeight: 500, color: "#1F3B78" }}>
                                        Courses
                                    </Typography>
                                    <ChevronRightIcon sx={{ fontSize: 15, color: "#8A96AA" }} />
                                    <Typography
                                        sx={{
                                            fontSize: 11.5,
                                            fontWeight: 500,
                                            color: "#1F3B78",
                                            maxWidth: { xs: 180, md: 300 },
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {displayedCourseTitle}
                                    </Typography>

                                    {showCourseDefinition ? (
                                        <>
                                            <ChevronRightIcon sx={{ fontSize: 15, color: "#8A96AA" }} />
                                            <Typography sx={{ fontSize: 11.5, fontWeight: 500, color: "#1F3B78" }}>
                                                Course Definition
                                            </Typography>
                                        </>
                                    ) : (
                                        <>
                                            <ChevronRightIcon sx={{ fontSize: 15, color: "#8A96AA" }} />
                                            <Typography sx={{ fontSize: 11.5, fontWeight: 500, color: "#1F3B78" }}>
                                                Module {activeModuleNumber}
                                            </Typography>

                                            {activeLessonIndex !== null && (
                                                <>
                                                    <ChevronRightIcon sx={{ fontSize: 15, color: "#8A96AA" }} />
                                                    <Typography
                                                        sx={{
                                                            fontSize: 11.5,
                                                            fontWeight: 500,
                                                            color: "#1F3B78",
                                                            maxWidth: { xs: 220, md: 330 },
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        Lesson {activeLessonIndex + 1}: {displayedLessonTitle}
                                                    </Typography>
                                                </>
                                            )}
                                        </>
                                    )}

                                    <ChevronRightIcon sx={{ fontSize: 15, color: "#8A96AA" }} />
                                    <Typography sx={{ fontSize: 11.5, fontWeight: 600, color: "#1F3B78" }}>
                                        Edit
                                    </Typography>
                                </Box>

                                <Grid container spacing={3} alignItems="stretch">

                                    {/* LEFT PANEL */}
                                    <Grid item xs={12} md={7}>
                                      {showCourseDefinition ? (
                                        <Paper
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                background: "transparent",
                                                border: "1px solid #E5E7EB",
                                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                            }}
                                        >
                                            <EditableFieldWrapper>
                                                <TextField
                                                    value={mainTitle || ""}
                                                    onChange={(e) => setMainTitle(e.target.value)}
                                                    variant="standard"
                                                    fullWidth
                                                    placeholder="Course title"
                                                    InputProps={{ disableUnderline: true }}
                                                    sx={{
                                                        mb: 1.5,
                                                        pr: 3,
                                                        "& .MuiInputBase-input": {
                                                            color: "#000 !important",
                                                            fontWeight: 600,
                                                            fontSize: { xs: "20px", md: "22px" },
                                                            lineHeight: 1.25,
                                                            padding: 0,
                                                        },
                                                    }}
                                                />
                                            </EditableFieldWrapper>

                                            <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#000", mb: 0.5 }}>
                                                Course Definition
                                            </Typography>
                                            <Typography sx={{ fontSize: "12.5px", color: "#6B7280", mb: 2.5 }}>
                                                Overview, audience, objectives, and what learners will achieve
                                            </Typography>

                                            <EditableFieldWrapper>
                                                <TextField
                                                    label="Course Description"
                                                    size="small"
                                                    fullWidth
                                                    multiline
                                                    minRows={4}
                                                    value={courseDescription}
                                                    onChange={(e: any) => setCourseDescription(e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{
                                                        mb: 2,
                                                        "& .MuiInputBase-input": { color: "#000" },
                                                        "& .MuiInputLabel-root": { color: "#000" },
                                                        "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "#E5E7EB" },
                                                            "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                            "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                        },
                                                    }}
                                                />
                                            </EditableFieldWrapper>

                                            <Box sx={{ display: "flex", gap: 1.5 }}>
                                                <EditableFieldWrapper sx={{ flex: 1 }}>
                                                    <TextField
                                                        label="Who This Course Is For"
                                                        size="small"
                                                        fullWidth
                                                        multiline
                                                        minRows={3}
                                                        value={courseTargetAudi}
                                                        onChange={(e: any) => setCourseTargetAudi(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            mb: 2,
                                                            "& .MuiInputBase-input": { color: "#000" },
                                                            "& .MuiInputLabel-root": { color: "#000" },
                                                            "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": { borderColor: "#E5E7EB" },
                                                                "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                            },
                                                        }}
                                                    />
                                                </EditableFieldWrapper>

                                                <EditableFieldWrapper sx={{ flex: 1 }}>
                                                    <TextField
                                                        label="Prerequisites"
                                                        size="small"
                                                        fullWidth
                                                        multiline
                                                        minRows={3}
                                                        value={coursePrerequisites}
                                                        onChange={(e: any) => setCoursePrerequisites(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            mb: 2,
                                                            "& .MuiInputBase-input": { color: "#000" },
                                                            "& .MuiInputLabel-root": { color: "#000" },
                                                            "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": { borderColor: "#E5E7EB" },
                                                                "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                            },
                                                        }}
                                                    />
                                                </EditableFieldWrapper>
                                            </Box>

                                            <Box sx={{ display: "flex", gap: 1.5 }}>
                                                <EditableFieldWrapper sx={{ flex: 1 }}>
                                                    <TextField
                                                        label="Learner Level"
                                                        size="small"
                                                        fullWidth
                                                        value={learner}
                                                        onChange={(e: any) => setLearner(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            mb: 2,
                                                            "& .MuiInputBase-input": { color: "#000" },
                                                            "& .MuiInputLabel-root": { color: "#000" },
                                                            "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": { borderColor: "#E5E7EB" },
                                                                "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                            },
                                                        }}
                                                    />
                                                </EditableFieldWrapper>

                                                <EditableFieldWrapper sx={{ flex: 1 }}>
                                                    <TextField
                                                        label="Duration"
                                                        size="small"
                                                        fullWidth
                                                        value={courseDuration}
                                                        onChange={(e: any) => setCourseDuration(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            mb: 2,
                                                            "& .MuiInputBase-input": { color: "#000" },
                                                            "& .MuiInputLabel-root": { color: "#000" },
                                                            "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": { borderColor: "#E5E7EB" },
                                                                "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                            },
                                                        }}
                                                    />
                                                </EditableFieldWrapper>
                                            </Box>

                                            <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
                                                <Box sx={{ flex: 1, p: 1.5, borderRadius: "10px", backgroundColor: "#F9FAFB", border: "1px solid #E5E7EB" }}>
                                                    <Typography sx={{ fontSize: "10px", color: "#6B7280" }}>Modules</Typography>
                                                    <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#111827" }}>
                                                        {curriculum.length}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ flex: 1, p: 1.5, borderRadius: "10px", backgroundColor: "#F9FAFB", border: "1px solid #E5E7EB" }}>
                                                    <Typography sx={{ fontSize: "10px", color: "#6B7280" }}>Lessons</Typography>
                                                    <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#111827" }}>
                                                        {curriculum.reduce((sum, w) => sum + (w.subtopics?.length || 0), 0)}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <EditableFieldWrapper>
                                                <TextField
                                                    label="Expected Outcome / What You'll Learn"
                                                    size="small"
                                                    fullWidth
                                                    multiline
                                                    minRows={4}
                                                    value={courseLearningOutcomes}
                                                    onChange={(e: any) => setCourseLearningOutcomes(e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{
                                                        "& .MuiInputBase-input": { color: "#000" },
                                                        "& .MuiInputLabel-root": { color: "#000" },
                                                        "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "#E5E7EB" },
                                                            "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                            "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                        },
                                                    }}
                                                />
                                            </EditableFieldWrapper>
                                        </Paper>
                                      ) : activeLessonIndex === null ? (
                                        <>
                                        {/* Module Title - Outside Paper */}
                                        <Box
                                            sx={{
                                                mb: 1.5,
                                                width: "100%",
                                            }}
                                        >
                                            <Paper
                                                sx={{
                                                    width: "100%",
                                                    p: 2.5,
                                                    borderRadius: 2,
                                                    background: "transparent",
                                                    border: "1px solid #E5E7EB",
                                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        component="span"
                                                        sx={{
                                                            fontSize: "16px",
                                                            fontWeight: 600,
                                                            color: "#000",
                                                            whiteSpace: "nowrap",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        Module {activeWeekIndex + 1}:
                                                    </Typography>

                                                    <EditableFieldWrapper sx={{ flex: 1, minWidth: 0 }}>
                                                        <TextField
                                                            fullWidth
                                                            variant="standard"
                                                            value={title1?.replace(/\bweeks?\b/i, "Module")}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                setTitle1(value);

                                                                setCurriculum((prev) => {
                                                                    const copy = [...prev];

                                                                    copy[activeWeekIndex] = {
                                                                        ...copy[activeWeekIndex],
                                                                        title: value,
                                                                    };

                                                                    return copy;
                                                                });
                                                            }}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                            sx={{
                                                                flex: 1,
                                                                minWidth: 0,
                                                                pr: 3,
                                                                input: {
                                                                    fontSize: "16px",
                                                                    fontWeight: 600,
                                                                    color: "#000 !important",
                                                                    padding: 0,
                                                                },
                                                            }}
                                                        />
                                                    </EditableFieldWrapper>
                                                </Box>
                                            </Paper>
                                        </Box>

                                        <Paper
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                background: "transparent",
                                                border: "1px solid #E5E7EB",
                                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                            }}
                                        >

                                            {/* Description */}
                                            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#000", mb: 1 }}>
                                                Description
                                            </Typography>

                                            <EditableFieldWrapper>
                                                <ReactQuill
                                                    key={`module-description-${activeWeekIndex}`}
                                                    value={moduleDescription}
                                                    onChange={(value) => {
                                                        setModuleDescription(value);

                                                        setCurriculum((prev) => {
                                                            const copy = [...prev];

                                                            copy[activeWeekIndex] = {
                                                                ...copy[activeWeekIndex],
                                                                module_objective: value,
                                                            };

                                                            return copy;
                                                        });
                                                    }}
                                                    theme="bubble"
                                                    modules={{
                                                        toolbar: [
                                                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                                            [{ list: "ordered" }, { list: "bullet" }],
                                                            ["bold", "italic", "underline"],
                                                            ["link"],
                                                            [
                                                                { align: "" },
                                                                { align: "center" },
                                                                { align: "right" },
                                                                { align: "justify" },
                                                            ],
                                                        ],
                                                    }}
                                                    className="curriculum-quill curriculum-quill--compact"
                                                    readOnly={false}
                                                />
                                            </EditableFieldWrapper>

                                            <Divider sx={{ my: 2 }} />

                                            {/* Module Learning Objectives */}
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                                                <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 20 }} />
                                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#000" }}>
                                                    Module Learning Objectives
                                                </Typography>
                                            </Box>

                                            <Stack spacing={0.5}>
                                                {moduleLearningObjectives.map((objective, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 1,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <EditableFieldWrapper sx={{ flex: 1, minWidth: 0 }}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                variant="standard"
                                                                value={objective}
                                                                onChange={(e) =>
                                                                    handleObjectiveChange(index, e.target.value)
                                                                }
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                                sx={{
                                                                    flex: 1,
                                                                    minWidth: 0,
                                                                    pr: 3,
                                                                    "& .MuiInputBase-input": {
                                                                        fontSize: "13px",
                                                                        color: "#000",
                                                                    },
                                                                }}
                                                            />
                                                        </EditableFieldWrapper>

                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleRemoveObjective(index)}
                                                            sx={{
                                                                flexShrink: 0,
                                                                color: "#ef4444",
                                                                width: 32,
                                                                height: 32,
                                                                "&:hover": {
                                                                    backgroundColor: "rgba(239, 68, 68, 0.08)",
                                                                    color: "#dc2626",
                                                                },
                                                            }}
                                                        >
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                ))}
                                            </Stack>

                                            <Button
                                                onClick={handleAddObjective}
                                                startIcon={<AddIcon fontSize="small" />}
                                                sx={{
                                                    mt: 1,
                                                    textTransform: "none",
                                                    color: "#2563eb",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    p: 0,
                                                    minWidth: "auto",
                                                    "&:hover": { background: "transparent", textDecoration: "underline" },
                                                }}
                                            >
                                                Add objective
                                            </Button>

                                            <Divider sx={{ mt: 2, mb: 2 }} />
                                            {/* Image */}
                                            {/* <Box
                                                sx={{
                                                    position: "relative",
                                                    borderRadius: 2,
                                                    overflow: "hidden",
                                                    mb: 2,
                                                }}
                                            >
                                                <Box
                                                    key={`${activeWeekIndex}-${courseImage}`}
                                                    component="img"
                                                    src={
                                                        !courseImage
                                                            ? ""
                                                            : /^(https?:|blob:)/i.test(courseImage)
                                                                ? courseImage
                                                                : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${courseImage.startsWith("/") ? "" : "/"
                                                                }${courseImage}`
                                                    }
                                                    sx={{
                                                        width: "100%",
                                                        height: { xs: 200, md: 280 },
                                                        objectFit: "contain",
                                                    }}
                                                />

                                                <Button
                                                    size="small"
                                                    onClick={() => setChoosingImageModal(true)}
                                                    sx={{
                                                        position: "absolute",
                                                        top: 10,
                                                        right: 10,
                                                        textTransform: "none",
                                                        background: "rgba(0,0,0,0.55)",
                                                        color: "#fff",
                                                        border: "1px solid #E5E7EB",
                                                        "&:hover": { background: "rgba(0,0,0,0.7)" },
                                                    }}
                                                >
                                                    Edit image
                                                </Button>

                                                <input
                                                    ref={fileRef}
                                                    hidden
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                />
                                            </Box> */}
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{
                                                        textTransform: "none",
                                                        borderColor: "#E5E7EB",
                                                        // color: "#cbd5f5",
                                                        color: '#000'
                                                    }}
                                                    disabled={activeWeekIndex === 0}
                                                    onClick={() =>
                                                        setActiveWeekIndex((prev) => Math.max(prev - 1, 0))
                                                    }
                                                >
                                                    <KeyboardArrowLeftIcon /> Previous Module
                                                </Button>

                                                <Typography
                                                    sx={{ fontSize: 12, color: '#000'/* "#9ca3af" */ }}
                                                >
                                                    {/* Week {curriculum[activeWeekIndex]?.week} */}
                                                    Module {activeWeekIndex + 1} of {curriculum.length}
                                                </Typography>

                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    sx={{
                                                        textTransform: "none",
                                                        background: "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                                        color: '#fff'
                                                    }}
                                                    disabled={activeWeekIndex === curriculum.length - 1}
                                                    onClick={() =>
                                                        setActiveWeekIndex((prev) =>
                                                            Math.min(prev + 1, curriculum.length - 1)
                                                        )
                                                    }
                                                >
                                                    Next Module <KeyboardArrowRightIcon />
                                                </Button>
                                            </Stack>
                                        </Paper>
                                        </>
                                      ) : (
                                        <>
                                        {/* Lesson Title - Outside Paper */}
                                        <Box sx={{ mb: 1.5, width: "100%" }}>
                                            <Paper
                                                sx={{
                                                    width: "100%",
                                                    p: 2.5,
                                                    borderRadius: 2,
                                                    background: "transparent",
                                                    border: "1px solid #E5E7EB",
                                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 1, mb: 1 }}>
                                                    <Typography
                                                        component="span"
                                                        sx={{
                                                            fontSize: "16px",
                                                            fontWeight: 600,
                                                            color: "#000",
                                                            whiteSpace: "nowrap",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        Lesson {activeLessonIndex + 1}:
                                                    </Typography>

                                                    <EditableFieldWrapper sx={{ flex: 1, minWidth: 0 }}>
                                                        <TextField
                                                            fullWidth
                                                            variant="standard"
                                                            value={lessonTitle}
                                                            onChange={(e) => handleLessonTitleChange(e.target.value)}
                                                            InputProps={{ disableUnderline: true }}
                                                            sx={{
                                                                flex: 1,
                                                                minWidth: 0,
                                                                pr: 3,
                                                                input: {
                                                                    fontSize: "16px",
                                                                    fontWeight: 600,
                                                                    color: "#000 !important",
                                                                    padding: 0,
                                                                },
                                                            }}
                                                        />
                                                    </EditableFieldWrapper>
                                                </Box>

                                                <Button
                                                    size="small"
                                                    startIcon={<KeyboardArrowLeftIcon />}
                                                    onClick={() => setActiveLessonIndex(null)}
                                                    sx={{
                                                        textTransform: "none",
                                                        color: "#2563eb",
                                                        fontSize: "13px",
                                                        p: 0,
                                                        minWidth: "auto",
                                                        "&:hover": { background: "transparent", textDecoration: "underline" },
                                                    }}
                                                >
                                                    Back to Module {activeWeekIndex + 1}
                                                </Button>
                                            </Paper>
                                        </Box>

                                        <Paper
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                background: "transparent",
                                                border: "1px solid #E5E7EB",
                                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                            }}
                                        >
                                            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#000", mb: 1 }}>
                                                Introduction
                                            </Typography>

                                            <EditableFieldWrapper>
                                                <ReactQuill
                                                    key={`lesson-introduction-${activeWeekIndex}-${activeLessonIndex}`}
                                                    value={lessonIntroduction}
                                                    onChange={handleLessonIntroductionChange}
                                                    theme="bubble"
                                                    modules={{
                                                        toolbar: [
                                                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                                            [{ list: "ordered" }, { list: "bullet" }],
                                                            ["bold", "italic", "underline"],
                                                            ["link"],
                                                        ],
                                                    }}
                                                    className="curriculum-quill curriculum-quill--compact"
                                                    readOnly={false}
                                                />
                                            </EditableFieldWrapper>

                                            <Divider sx={{ my: 2 }} />

                                            {/* Sections */}
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                                                <MenuBookOutlinedIcon sx={{ color: "#2563eb", fontSize: 20 }} />
                                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#000" }}>
                                                    Sections
                                                </Typography>
                                            </Box>

                                            <Stack spacing={1.5}>
                                                {lessonSections.map((section, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            border: "1px dashed #E5E7EB",
                                                            borderRadius: 1.5,
                                                            p: 1.5,
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleRemoveLessonSection(index)}
                                                            sx={{
                                                                position: "absolute",
                                                                top: 4,
                                                                right: 4,
                                                                color: "#ef4444",
                                                                width: 28,
                                                                height: 28,
                                                                "&:hover": {
                                                                    backgroundColor: "rgba(239, 68, 68, 0.08)",
                                                                    color: "#dc2626",
                                                                },
                                                            }}
                                                        >
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>

                                                        <EditableFieldWrapper iconSx={{ right: 36 }}>
                                                            <TextField
                                                                label="Heading"
                                                                size="small"
                                                                fullWidth
                                                                value={section.heading}
                                                                onChange={(e) =>
                                                                    handleLessonSectionFieldChange(index, "heading", e.target.value)
                                                                }
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    mb: 1,
                                                                    pr: 3,
                                                                    "& .MuiInputBase-input": { color: "#000", fontSize: "13px" },
                                                                    "& .MuiInputLabel-root": { color: "#000" },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": { borderColor: "#E5E7EB" },
                                                                        "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                        "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                                    },
                                                                }}
                                                            />
                                                        </EditableFieldWrapper>

                                                        <EditableFieldWrapper>
                                                            <TextField
                                                                label="Content"
                                                                size="small"
                                                                fullWidth
                                                                multiline
                                                                minRows={3}
                                                                maxRows={6}
                                                                value={section.content}
                                                                onChange={(e) =>
                                                                    handleLessonSectionFieldChange(index, "content", e.target.value)
                                                                }
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiInputBase-input": { color: "#000", fontSize: "13px" },
                                                                    "& .MuiInputLabel-root": { color: "#000" },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": { borderColor: "#E5E7EB" },
                                                                        "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                        "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                                    },
                                                                }}
                                                            />
                                                        </EditableFieldWrapper>
                                                    </Box>
                                                ))}
                                            </Stack>

                                            <Button
                                                onClick={handleAddLessonSection}
                                                startIcon={<AddIcon fontSize="small" />}
                                                sx={{
                                                    mt: 1,
                                                    textTransform: "none",
                                                    color: "#2563eb",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    p: 0,
                                                    minWidth: "auto",
                                                    "&:hover": { background: "transparent", textDecoration: "underline" },
                                                }}
                                            >
                                                Add section
                                            </Button>

                                            <Divider sx={{ my: 2 }} />

                                            {/* Examples (was previously reading the empty "example" string field;
                                               now correctly reads/writes the "examples" array from the API) */}
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                                                <DescriptionOutlinedIcon sx={{ color: "#2563eb", fontSize: 20 }} />
                                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#000" }}>
                                                    Examples
                                                </Typography>
                                            </Box>

                                            <Stack spacing={1.5}>
                                                {lessonExamples.map((example, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            border: "1px dashed #E5E7EB",
                                                            borderRadius: 1.5,
                                                            p: 1.5,
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleRemoveLessonExample(index)}
                                                            sx={{
                                                                position: "absolute",
                                                                top: 4,
                                                                right: 4,
                                                                color: "#ef4444",
                                                                width: 28,
                                                                height: 28,
                                                                "&:hover": {
                                                                    backgroundColor: "rgba(239, 68, 68, 0.08)",
                                                                    color: "#dc2626",
                                                                },
                                                            }}
                                                        >
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>

                                                        <EditableFieldWrapper iconSx={{ right: 36 }}>
                                                            <TextField
                                                                label="Title"
                                                                size="small"
                                                                fullWidth
                                                                value={example.title}
                                                                onChange={(e) =>
                                                                    handleLessonExampleFieldChange(index, "title", e.target.value)
                                                                }
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    mb: 1,
                                                                    pr: 3,
                                                                    "& .MuiInputBase-input": { color: "#000", fontSize: "13px" },
                                                                    "& .MuiInputLabel-root": { color: "#000" },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": { borderColor: "#E5E7EB" },
                                                                        "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                        "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                                    },
                                                                }}
                                                            />
                                                        </EditableFieldWrapper>

                                                        <EditableFieldWrapper>
                                                            <TextField
                                                                label="Content"
                                                                size="small"
                                                                fullWidth
                                                                multiline
                                                                minRows={3}
                                                                maxRows={6}
                                                                value={example.content}
                                                                onChange={(e) =>
                                                                    handleLessonExampleFieldChange(index, "content", e.target.value)
                                                                }
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiInputBase-input": { color: "#000", fontSize: "13px" },
                                                                    "& .MuiInputLabel-root": { color: "#000" },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": { borderColor: "#E5E7EB" },
                                                                        "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                                        "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                                    },
                                                                }}
                                                            />
                                                        </EditableFieldWrapper>
                                                    </Box>
                                                ))}
                                            </Stack>

                                            <Button
                                                onClick={handleAddLessonExample}
                                                startIcon={<AddIcon fontSize="small" />}
                                                sx={{
                                                    mt: 1,
                                                    textTransform: "none",
                                                    color: "#2563eb",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    p: 0,
                                                    minWidth: "auto",
                                                    "&:hover": { background: "transparent", textDecoration: "underline" },
                                                }}
                                            >
                                                Add example
                                            </Button>

                                            <Divider sx={{ my: 2 }} />

                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                                                <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 20 }} />
                                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#000" }}>
                                                    Key Takeaways
                                                </Typography>
                                            </Box>

                                            <Stack spacing={0.5}>
                                                {lessonKeyTakeaways.map((takeaway, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 1,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <EditableFieldWrapper sx={{ flex: 1, minWidth: 0 }}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                variant="standard"
                                                                value={takeaway}
                                                                onChange={(e) =>
                                                                    handleLessonKeyTakeawayChange(index, e.target.value)
                                                                }
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                                sx={{
                                                                    flex: 1,
                                                                    minWidth: 0,
                                                                    pr: 5,
                                                                    "& .MuiInputBase-input": {
                                                                        fontSize: "13px",
                                                                        color: "#000",
                                                                    },
                                                                }}
                                                            />
                                                        </EditableFieldWrapper>

                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleRemoveLessonKeyTakeaway(index)}
                                                            sx={{
                                                                flexShrink: 0,
                                                                color: "#ef4444",
                                                                width: 32,
                                                                height: 32,
                                                                "&:hover": {
                                                                    backgroundColor: "rgba(239, 68, 68, 0.08)",
                                                                    color: "#dc2626",
                                                                },
                                                            }}
                                                        >
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                ))}
                                            </Stack>

                                            <Button
                                                onClick={handleAddLessonKeyTakeaway}
                                                startIcon={<AddIcon fontSize="small" />}
                                                sx={{
                                                    mt: 1,
                                                    textTransform: "none",
                                                    color: "#2563eb",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    p: 0,
                                                    minWidth: "auto",
                                                    "&:hover": { background: "transparent", textDecoration: "underline" },
                                                }}
                                            >
                                                Add takeaway
                                            </Button>

                                            <Divider sx={{ my: 2 }} />

                                            <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ textTransform: "none", borderColor: "#E5E7EB", color: "#000" }}
                                                    disabled={activeLessonIndex === 0}
                                                    onClick={() =>
                                                        setActiveLessonIndex((prev) => Math.max((prev ?? 0) - 1, 0))
                                                    }
                                                >
                                                    <KeyboardArrowLeftIcon /> Previous Lesson
                                                </Button>

                                                <Typography sx={{ fontSize: 12, color: "#000" }}>
                                                    Lesson {activeLessonIndex + 1} of{" "}
                                                    {curriculum[activeWeekIndex]?.subtopics?.length || 0}
                                                </Typography>

                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    sx={{
                                                        textTransform: "none",
                                                        background: "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                                        color: "#fff",
                                                    }}
                                                    disabled={
                                                        activeLessonIndex ===
                                                        (curriculum[activeWeekIndex]?.subtopics?.length || 1) - 1
                                                    }
                                                    onClick={() =>
                                                        setActiveLessonIndex((prev) =>
                                                            Math.min(
                                                                (prev ?? 0) + 1,
                                                                (curriculum[activeWeekIndex]?.subtopics?.length || 1) - 1
                                                            )
                                                        )
                                                    }
                                                >
                                                    Next Lesson <KeyboardArrowRightIcon />
                                                </Button>
                                            </Stack>
                                        </Paper>
                                        </>
                                      )}
                                    </Grid>

                                    {/* RIGHT PANEL */}
                                    <Grid item xs={12} md={5} sx={{ display: "flex" }}>
                                        <Paper
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                background: "transparent",
                                                border: "1px solid #E5E7EB",
                                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",

                                                width: "100%",
                                                height: "100%",
                                                boxSizing: "border-box",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Stack sx={{ flex: 1 }}>
                                              {activeLessonIndex === null ? (
                                                <>
                                                {/* Course / Module Illustration */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        mb: 1.25,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                            color: "#111827",
                                                        }}
                                                    >
                                                        {showCourseDefinition
                                                            ? "Course Illustration"
                                                            : "Module Illustration"}
                                                    </Typography>

                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => {
                                                            setChoosingLessonImage(false);
                                                            setChoosingImageModal(true);
                                                        }}
                                                        sx={{
                                                            minWidth: "90px",
                                                            height: "32px",
                                                            px: 1.5,
                                                            borderRadius: "7px",
                                                            borderColor: "#E5E7EB",
                                                            color: "#1F2937",
                                                            backgroundColor: "#FFFFFF",
                                                            textTransform: "none",
                                                            fontSize: "11px",
                                                            fontWeight: 600,
                                                            boxShadow: "none",
                                                            "&:hover": {
                                                                borderColor: "#D1D5DB",
                                                                backgroundColor: "#FAFAFA",
                                                                boxShadow: "none",
                                                            },
                                                        }}
                                                    >
                                                        Change Image
                                                    </Button>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        borderRadius: 2,
                                                        overflow: "hidden",
                                                        mb: 2,

                                                        // Scroll only when image is taller than this area
                                                        maxHeight: { xs: 300, md: 300/* 450 */ },
                                                        overflowY: "auto",

                                                        // Keep horizontal overflow hidden
                                                        overflowX: "hidden",

                                                        // Optional scrollbar styling
                                                        "&::-webkit-scrollbar": {
                                                            width: "6px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                            background: "#999",
                                                            borderRadius: "10px",
                                                        },
                                                        "&::-webkit-scrollbar-track": {
                                                            background: "#f1f1f1",
                                                        },
                                                    }}
                                                >
                                                    <Box
                                                        key={`${activeWeekIndex}-${showCourseDefinition ? courseDefinitionImage : courseImage}`}
                                                        component="img"
                                                        src={
                                                            (() => {
                                                                const imgSrc = showCourseDefinition ? courseDefinitionImage : courseImage;
                                                                if (!imgSrc) return "";
                                                                return /^(https?:|blob:)/i.test(imgSrc)
                                                                    ? imgSrc
                                                                    : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${imgSrc.startsWith("/") ? "" : "/"
                                                                    }${imgSrc}`;
                                                            })()
                                                        }
                                                        sx={{
                                                            width: "100%",
                                                            height: "auto",
                                                            display: "block",
                                                            objectFit: "contain",
                                                        }}
                                                    />

                                                    <input
                                                        ref={fileRef}
                                                        hidden
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleImageChange}
                                                    />
                                                </Box>

                                                <Divider sx={{ mb: 2 }} />

                                                {!showCourseDefinition && (
                                                <>
                                                <Typography fontSize="16px" color='#000'/* "#9ca3af" */ mb={2}>
                                                    Section content
                                                </Typography>

                                                <TextField
                                                    label="Title"
                                                    // value="Design Blog"
                                                    value={title1?.replace(/\bweeks?\b/i, "Module")}
                                                    // onChange={(e) => setTitle(e.target.value)}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setTitle1(value);

                                                        setCurriculum((prev) => {
                                                            const copy = [...prev];
                                                            copy[activeWeekIndex] = {
                                                                ...copy[activeWeekIndex],
                                                                title: value,
                                                            };
                                                            return copy;
                                                        });
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                    // sx={{ mb: 2 }}
                                                    sx={{
                                                        mb: 2,

                                                        // Label
                                                        "& .MuiInputLabel-root": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },

                                                        // Input text
                                                        "& .MuiInputBase-input": {
                                                            color: "#000",
                                                        },

                                                        // Border
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#E5E7EB",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#E5E7EB",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#E5E7EB",
                                                            },
                                                        },
                                                    }}
                                                />
                                                </>
                                                )}

                                                <Divider sx={{ borderColor: '#fff !important', mb: 2 }} />
                                                </>
                                              ) : (
                                                <>
                                                {/* Lesson Illustration */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        mb: 1.25,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                            color: "#111827",
                                                        }}
                                                    >
                                                        Lesson Illustration
                                                    </Typography>

                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => {
                                                            setChoosingLessonImage(true);
                                                            setChoosingImageModal(true);
                                                        }}
                                                        sx={{
                                                            minWidth: "90px",
                                                            height: "32px",
                                                            px: 1.5,
                                                            borderRadius: "7px",
                                                            borderColor: "#E5E7EB",
                                                            color: "#1F2937",
                                                            backgroundColor: "#FFFFFF",
                                                            textTransform: "none",
                                                            fontSize: "11px",
                                                            fontWeight: 600,
                                                            boxShadow: "none",
                                                            "&:hover": {
                                                                borderColor: "#D1D5DB",
                                                                backgroundColor: "#FAFAFA",
                                                                boxShadow: "none",
                                                            },
                                                        }}
                                                    >
                                                        Change Image
                                                    </Button>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        borderRadius: 2,
                                                        overflow: "hidden",
                                                        mb: 2,
                                                        maxHeight: { xs: 300, md: 300 },
                                                        overflowY: "auto",
                                                        overflowX: "hidden",
                                                        "&::-webkit-scrollbar": { width: "6px" },
                                                        "&::-webkit-scrollbar-thumb": {
                                                            background: "#999",
                                                            borderRadius: "10px",
                                                        },
                                                        "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
                                                    }}
                                                >
                                                    <Box
                                                        key={`${activeWeekIndex}-${activeLessonIndex}-${lessonImage}`}
                                                        component="img"
                                                        src={
                                                            !lessonImage
                                                                ? ""
                                                                : /^(https?:|blob:)/i.test(lessonImage)
                                                                    ? lessonImage
                                                                    : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${lessonImage.startsWith("/") ? "" : "/"
                                                                    }${lessonImage}`
                                                        }
                                                        sx={{
                                                            width: "100%",
                                                            height: "auto",
                                                            display: "block",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </Box>

                                                <Divider sx={{ mb: 2 }} />

                                                <Typography fontSize="16px" color='#000' mb={2}>
                                                    Lesson content
                                                </Typography>

                                                <TextField
                                                    label="Lesson Title"
                                                    value={lessonTitle}
                                                    onChange={(e) => handleLessonTitleChange(e.target.value)}
                                                    size="small"
                                                    fullWidth
                                                    sx={{
                                                        mb: 2,
                                                        "& .MuiInputLabel-root": { color: "#000" },
                                                        "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                        "& .MuiInputBase-input": { color: "#000" },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "#E5E7EB" },
                                                            "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                            "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                        },
                                                    }}
                                                />

                                                <TextField
                                                    label="Lesson Length"
                                                    value={lessonLength}
                                                    onChange={(e) => handleLessonLengthChange(e.target.value)}
                                                    size="small"
                                                    fullWidth
                                                    sx={{
                                                        mb: 2,
                                                        "& .MuiInputLabel-root": { color: "#000" },
                                                        "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
                                                        "& .MuiInputBase-input": { color: "#000" },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "#E5E7EB" },
                                                            "&:hover fieldset": { borderColor: "#E5E7EB" },
                                                            "&.Mui-focused fieldset": { borderColor: "#E5E7EB" },
                                                        },
                                                    }}
                                                />

                                                <Divider sx={{ borderColor: '#fff !important', mb: 2 }} />
                                                </>
                                              )}

                                                {/* <Typography fontSize="16px" color="#9ca3af">
                                                Section content
                                            </Typography> */}

                                                <Typography fontSize="14px" color='#000'/* "#9ca3af" */ mb={2}>
                                                    Course Details{/*  - <a href="">Current</a> */}
                                                </Typography>

                                                {/* Pricing */}
                                                <FormControl sx={{ mb: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            // fontWeight: 600,
                                                            color: "#000",
                                                            mb: 0.5,
                                                        }}
                                                    >
                                                        Pricing
                                                    </Typography>

                                                    <RadioGroup
                                                        row
                                                        value={priceType}
                                                        onChange={(e) => {
                                                            setPriceType(e.target.value);
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="free"
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    sx={{
                                                                        color: "#000",
                                                                        "&.Mui-checked": {
                                                                            color: "#1976d2",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "13px",
                                                                        color: "#000",
                                                                    }}
                                                                >
                                                                    Free Course
                                                                </Typography>
                                                            }
                                                        />

                                                        <FormControlLabel
                                                            value="paid"
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    sx={{
                                                                        color: "#000",
                                                                        "&.Mui-checked": {
                                                                            color: "#1976d2",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "13px",
                                                                        color: "#000",
                                                                    }}
                                                                >
                                                                    Paid Course
                                                                </Typography>
                                                            }
                                                        />
                                                    </RadioGroup>
                                                </FormControl>

                                                {/* Suggested Price + Currency */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: 1,
                                                        mb: 2,
                                                        width: "100%",
                                                    }}
                                                >
                                                    <TextField
                                                        label="Price"
                                                        size="small"
                                                        fullWidth
                                                        type="number"
                                                        value={coursePrice}
                                                        disabled={priceType === "free"}
                                                        onChange={(e) => setCoursePrice(e.target.value)}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        sx={{
                                                            "& .MuiInputBase-input": {
                                                                color: "#000",
                                                            },

                                                            "& .MuiInputLabel-root": {
                                                                color: "#000",
                                                            },

                                                            "& .MuiInputLabel-root.Mui-focused": {
                                                                color: "#000",
                                                            },

                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#E5E7EB",
                                                                },
                                                                "&:hover fieldset": {
                                                                    borderColor: "#E5E7EB",
                                                                },
                                                                "&.Mui-focused fieldset": {
                                                                    borderColor: "#E5E7EB",
                                                                },
                                                            },

                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                WebkitTextFillColor: "#777",
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                                                                borderColor: "#E5E7EB",
                                                            },
                                                        }}
                                                    />

                                                    <TextField
                                                        value="USD"
                                                        size="small"
                                                        disabled
                                                        sx={{
                                                            width: "90px",

                                                            "& .MuiInputBase-input": {
                                                                color: "#000",
                                                                fontWeight: 500,
                                                            },

                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                WebkitTextFillColor: "#000",
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                                                                borderColor: "#E5E7EB",
                                                            },
                                                        }}
                                                    />
                                                </Box>

                                                {/* <Box> */}
                                                {/* <Typography fontSize="12px" color="#9ca3af" mb={0.5}>
                                                    Progress
                                                </Typography> */}
                                                {/* <TextField
                                                    value={`Progress ${courseDetails?.content_generation_progress?.generated}`}
                                                    size="small"
                                                    fullWidth
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                    sx={{
                                                        pointerEvents: "none"
                                                    }}
                                                /> */}

                                                {/* <LinearProgress
                                                    variant="determinate"
                                                    value={50}
                                                    sx={{
                                                        height: 6,
                                                        borderRadius: 4,
                                                        backgroundColor: "#374151",
                                                        "& .MuiLinearProgress-bar": {
                                                            backgroundColor: "#2563eb",
                                                        },
                                                    }}
                                                /> */}
                                                {/* </Box> */}

                                                <Typography fontSize="14px" color='#000'/* "#9ca3af" */>
                                                    Instructor Profile Image
                                                </Typography>
                                                {/* <Typography fontSize="16px" sx={{
                                                    color: "#60a5fa",
                                                    cursor: "pointer",
                                                    textDecoration: "underline",
                                                    display: "inline-block",
                                                    mb: 3
                                                }} onClick={() => {
                                                    localStorage.setItem('activeItem', 'settings');
                                                    navigate('/codegenie/generated-blogs');
                                                }}>
                                                    Change profile Image here
                                                </Typography> */}
                                                <input
                                                    id="instructor-profile-image-input"
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleImageUpload(e.target.files?.[0] || null)}
                                                />

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, mt: 1 }}>
                                                    {(instructorDetails.profileImagePreview || instructorDetails.existingImageUrl) && (
                                                        <img
                                                            src={instructorDetails.profileImagePreview || instructorDetails.existingImageUrl}
                                                            alt="Instructor"
                                                            style={{
                                                                width: '56px',
                                                                height: '56px',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                                border: '2px solid #E5E7EB'
                                                            }}
                                                        />
                                                    )}
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => document.getElementById('instructor-profile-image-input')?.click()}
                                                        sx={{
                                                            textTransform: 'none',
                                                            borderColor: '#E5E7EB',
                                                            color: '#000',
                                                            '&:hover': { borderColor: '#3b82f6', color: '#3b82f6' }
                                                        }}
                                                    >
                                                        {(instructorDetails.profileImagePreview || instructorDetails.existingImageUrl) ? 'Change Photo' : 'Upload Photo'}
                                                    </Button>
                                                </Box>
                                                {/* <Button
                                                component="label"
                                                size="small"
                                                sx={{
                                                    textTransform: "none",
                                                    border: "1px solid #E5E7EB",
                                                    color: "#cbd5f5",
                                                }}
                                            >
                                                Choose file
                                                <input
                                                    // hidden
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) =>
                                                        handleImageUpload(e.target.files?.[0] || null)
                                                    }
                                                />
                                            </Button> */}
                                                {/* {instructorDetails.profileImagePreview && (
                                                <Box mt={2}>
                                                    <img
                                                        src={instructorDetails.profileImagePreview}
                                                        alt="Instructor"
                                                        style={{
                                                            width: "120px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "50%", // circle DP look
                                                            border: "2px solid #E5E7EB"
                                                        }}
                                                    />
                                                </Box>
                                            )} */}

                                                <TextField
                                                    label="Profile Page URL"
                                                    size="small"
                                                    fullWidth
                                                    // value={instructorDetails.profileUrl}
                                                    /* onChange={(e) =>
                                                        handleInstructorChange("profileUrl", e.target.value)
                                                    } */
                                                    value={`${window.location.origin}/profile/${userDetails?.profile_id}`}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    onClick={() => {
                                                        window.open(
                                                            `${window.location.origin}/profile/${encodeURIComponent(
                                                                userDetails?.profile_id || ""
                                                            )}`,
                                                            "_blank"
                                                        );
                                                    }}
                                                    /* sx={{
                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                        },
                                                        mb: 2
                                                    }} */
                                                    sx={{
                                                        mb: 2,

                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                            color: "#000",
                                                        },

                                                        // Label
                                                        "& .MuiInputLabel-root": {
                                                            color: "#000"
                                                        },
                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#E5E7EB !important",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#E5E7EB !important",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#E5E7EB !important",
                                                            },
                                                        },
                                                        // Border
                                                        // "& .MuiOutlinedInput-root": {
                                                        //     "& fieldset": {
                                                        //         borderColor: "#E5E7EB",
                                                        //     },
                                                        //     "&:hover fieldset": {
                                                        //         borderColor: "#E5E7EB",
                                                        //     },
                                                        //     "&.Mui-focused fieldset": {
                                                        //         borderColor: "#E5E7EB",
                                                        //     },
                                                        // },
                                                    }}
                                                />

                                                <TextField
                                                    label="View Course"
                                                    size="small"
                                                    fullWidth
                                                    // value={instructorDetails.profileUrl}
                                                    /* onChange={(e) =>
                                                        handleInstructorChange("profileUrl", e.target.value)
                                                    } */
                                                    value={instructorDetails.profileUrl1}
                                                    inputProps={{
                                                        readOnly: true,
                                                    }}
                                                    /* sx={{
                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                        },
                                                        mb: 2
                                                    }} */
                                                    sx={{
                                                        mb: 2,

                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                            color: "#000",
                                                        },

                                                        // Label
                                                        "& .MuiInputLabel-root": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#E5E7EB !important",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#E5E7EB !important",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#E5E7EB !important",
                                                            },
                                                        },
                                                        // Border
                                                        // "& .MuiOutlinedInput-root": {
                                                        //     "& fieldset": {
                                                        //         borderColor: "#E5E7EB",
                                                        //     },
                                                        //     "&:hover fieldset": {
                                                        //         borderColor: "#E5E7EB",
                                                        //     },
                                                        //     "&.Mui-focused fieldset": {
                                                        //         borderColor: "#E5E7EB",
                                                        //     },
                                                        // },
                                                    }}
                                                    onClick={() => {
                                                        window.open(
                                                            `${instructorDetails.profileUrl1}`,
                                                            "_blank"
                                                        );
                                                    }}
                                                />

                                                {/* <TextField
                                                label="CTA Label"
                                                size="small"
                                                fullWidth
                                                value={instructorDetails.ctaLabel}
                                                onChange={(e) =>
                                                    handleInstructorChange("ctaLabel", e.target.value)
                                                }
                                            />

                                            <TextField
                                                label="CTA URL"
                                                size="small"
                                                fullWidth
                                                value={instructorDetails.ctaUrl}
                                                onChange={(e) =>
                                                    handleInstructorChange("ctaUrl", e.target.value)
                                                }
                                            /> */}

                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    sx={{
                                                        mt: 1,
                                                        textTransform: "none",
                                                        background:
                                                            "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                                        color: '#fff'
                                                    }}
                                                    onClick={() => videoInputRef.current?.click()}
                                                >
                                                    Add Introduction Video
                                                    <input
                                                        hidden
                                                        type="file"
                                                        accept="video/*"
                                                        onChange={(e) =>
                                                            handleVideoUpload(e.target.files?.[0] || null)
                                                        }
                                                        ref={videoInputRef}
                                                    />
                                                </Button>
                                                {videoSrc/* instructorDetails.introVideoPreview */ && (
                                                    <Box mt={2} sx={{ position: "relative" }}>
                                                        <Tooltip title="Remove video">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => setDeleteVideoModalOpen(true)}
                                                                sx={{
                                                                    position: "absolute",
                                                                    top: 8,
                                                                    right: 8,
                                                                    zIndex: 2,
                                                                    background: "rgba(0,0,0,0.55)",
                                                                    "&:hover": { background: "rgba(0,0,0,0.75)" },
                                                                }}
                                                            >
                                                                <DeleteOutlineIcon sx={{ fontSize: 18, color: "#fff" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <video
                                                            width="100%"
                                                            controls
                                                            style={{ borderRadius: "8px" }}
                                                            key={videoSrc}
                                                        >
                                                            <source
                                                                src={videoSrc
                                                                    /*  instructorDetails.introVideo
                                                                         ? instructorDetails.introVideoPreview
                                                                         : process.env.REACT_APP_SERVER_ENDPOINT + instructorDetails.introVideoPreview */
                                                                }
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </Box>
                                                )}
                                            </Stack>
                                        </Paper>
                                    </Grid>
    
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                            </Paper>
                        </Box>

                        {/* Modals */}

                        <Modal
                            open={deleteVideoModalOpen}
                            onClose={() => !isDeletingVideo && setDeleteVideoModalOpen(false)}
                            disableEscapeKeyDown
                            aria-labelledby="delete-video-modal-title"
                            aria-describedby="delete-video-modal-description"
                        >
                            <Box
                                sx={{
                                    position: "absolute" as "absolute",
                                    top: "50%",
                                    left: "50%",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    transform: "translate(-50%, -50%)",
                                    width: isMobile ? "90%" : 420,
                                    bgcolor: "#161b22",
                                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)',
                                    pt: 4,
                                    px: 4,
                                    pb: 3,
                                    borderRadius: '15px',
                                }}
                            >
                                <IconButton
                                    onClick={() => setDeleteVideoModalOpen(false)}
                                    disabled={isDeletingVideo}
                                    sx={{
                                        position: 'absolute',
                                        top: '6px',
                                        right: '7px',
                                        color: '#fff',
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>

                                <Typography id="delete-video-modal-title" style={{ color: '#fff', textAlign: 'center', fontWeight: 'bold', fontSize: 18 }}>
                                    Delete Introduction Video?
                                </Typography>
                                <Typography id="delete-video-modal-description" style={{ color: '#9ca3af', textAlign: 'center', fontSize: 13, marginTop: 8 }}>
                                    This will remove the introduction video from your course. This action cannot be undone.
                                </Typography>

                                <Stack flexDirection="row" sx={{ display: 'flex', gap: '16px', marginTop: '24px' }}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => setDeleteVideoModalOpen(false)}
                                        disabled={isDeletingVideo}
                                        sx={{ minWidth: 100, borderColor: "#21262d", color: "#9ca3af" }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={handleConfirmDeleteVideo}
                                        disabled={isDeletingVideo}
                                        sx={{ minWidth: 100 }}
                                    >
                                        {isDeletingVideo ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Delete"}
                                    </Button>
                                </Stack>
                            </Box>
                        </Modal>

                        {/* unsplash */}
                        {/* <Modal
                            open={showUnsplash}
                            onClose={() => setShowUnsplash(false)}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: { xs: "95%", md: 800 },
                                    bgcolor: "#0b1220",
                                    borderRadius: 5,
                                    p: 5,
                                    maxHeight: "80vh",
                                    overflowY: "auto",
                                    outline: "none"
                                }}
                            >
                                <Typography sx={{ mb: 1.5, color: "#fff", fontWeight: 600 }}>
                                    Choose an image from Unsplash
                                </Typography>

                                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Search images (eg: education, coding, classroom...)"
                                        value={unsplashSearch}
                                        onChange={(e) => setUnsplashSearch(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                openUnsplashPicker(unsplashSearch);
                                            }
                                        }}
                                        sx={{
                                            input: { color: "#fff" }
                                        }}
                                    />

                                    <Button
                                        variant="contained"
                                        onClick={() => openUnsplashPicker(unsplashSearch)}
                                        sx={{ whiteSpace: "nowrap" }}
                                    >
                                        Search
                                    </Button>
                                </Box>

                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(4, 1fr)",
                                        gap: 1
                                    }}
                                >
                                    {unsplashImages.map((img) => (
                                        <Box
                                            key={img.id}
                                            component="img"
                                            src={img.urls.small}
                                            onClick={() => handleSelectUnsplashImage(img)}
                                            sx={{
                                                width: "100%",
                                                height: 110,
                                                objectFit: "cover",
                                                cursor: "pointer",
                                                borderRadius: 1,
                                                border:
                                                    selectedUnsplashImage === img.urls.raw
                                                        ? "2px solid #3b82f6"
                                                        : "1px solid #374151"
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Box>
                        </Modal> */}

                        {/* unsplash and local image selection */}
                        <Modal
                            open={choosingImageModal}
                            onClose={() => setChoosingImageModal(false)}
                            disableEscapeKeyDown
                            aria-labelledby="child-modal-title"
                            aria-describedby="child-modal-description"
                        >
                            <Box
                                sx={{
                                    position: "absolute" as "absolute",
                                    top: "50%",
                                    left: "50%",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    transform: "translate(-50%, -50%)",
                                    width: isMobile ? "95%" : "40%",
                                    bgcolor: "#161b22",
                                    // border: "2px solid #000",
                                    // boxShadow: 24,
                                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)',
                                    pt: 2,
                                    px: 4,
                                    pb: 3,
                                    borderRadius: '15px',
                                    padding: '3%'
                                }}
                            >
                                <IconButton
                                    onClick={() => setChoosingImageModal(false)}
                                    sx={{
                                        position: 'absolute',
                                        top: '6px',
                                        right: '7px',
                                        color: '#fff',
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>

                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>{/* <InfoIcon sx={{ color: '#ffcc00' }} /><br /> */}Choose your image from below options</Typography>

                                <Stack flexDirection="row" sx={{ display: 'flex', gap: '20px', marginTop: '5%' }}>

                                    {/*  <Button
                            variant="contained"
                            onClick={() => handleDelete(deleteBlogId)}>
                            Yes
                        </Button> */}
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} onClick={handleImageClick}>
                                        <ComputerIcon sx={{ fontSize: '3rem' }} />
                                        <p style={{ color: '#fff' }}>Choose from folder</p>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*"
                                            style={{ /* width: '100%', */ display: 'none' }}
                                            onChange={handleImageChange}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={unsplashImg} style={{ width: '28%', height: '48px',/* , marginTop: '2%' */ background: 'transparent' }} onClick={() => setOpenUnsplash(true)} />
                                        <p style={{ color: '#fff' }}>Choose from Unsplash</p>
                                    </div>
                                    {/* <Button
                            onClick={() => setDeleteModal(false)}
                            variant="contained"
                        sx={{ mr: 2, marginTop: '15%' }}
                        >
                            No
                        </Button> */}
                                </Stack>
                            </Box>
                        </Modal>

                        <Modal
                            open={openUnsplash}
                            onClose={() => setOpenUnsplash(false)}
                            aria-labelledby="child-modal-title"
                            aria-describedby="child-modal-description"
                        >
                            <Box
                                sx={{
                                    position: "absolute" as "absolute",
                                    top: "50%",
                                    left: "50%",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    transform: "translate(-50%, -50%)",
                                    width: isMobile ? "90%" : "54%",
                                    bgcolor: "#161b22",
                                    // border: "2px solid #000",
                                    // boxShadow: 24,
                                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 1.2)',
                                    pt: 2,
                                    px: 4,
                                    pb: 3,
                                    borderRadius: '10px',
                                    overflowY: isMobile ? 'auto' : 'hidden',
                                    height: isMobile ? '600px' : '650px',
                                    maxHeight: '650px'
                                }}
                            >
                                <div className="row" style={{ width: '100%', marginTop: '5%' }}>
                                    <div className=" col-sm-12 col-md-10 col-lg-10">
                                        <TextField
                                            placeholder="Search Unsplash images"
                                            size="small"
                                            InputLabelProps={{
                                                className: 'red-label'
                                            }}
                                            InputProps={{
                                                /*  ...params.InputProps, */
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            sx={{
                                                '& .MuiInputBase-input::placeholder': {
                                                    color: 'white',
                                                    opacity: 1
                                                },
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' }, backgroundColor: '#0d1117' },
                                                '& .MuiInputBase-input': { color: '#e5e7eb' },
                                                '& .MuiSvgIcon-root': { color: '#6b7280' }
                                            }}
                                            value={query}
                                            onChange={(e) => setQuery(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-sm-12 col-md-2 col-lg-2" style={{ marginTop: isMobile ? '2%' : '' }}>
                                        <Button variant="contained" onClick={handleSearch} sx={{ fontWeight: 'bold', width: isMobile ? '100%' : '' }}>Search</Button>
                                    </div>
                                    {/* <div className="col-md-8">
                        <Typography component="div">
                        <input
                            type="text"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Search Unsplash images"
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '1rem',
                                border: '1px solid #E5E7EB',
                                borderRadius: '4px',
                                marginBottom: '1rem',
                            }}
                        />
                        </Typography>
                        </div>
                        <div className="col-md-4">
                        <Button variant="contained" onClick={handleSearch}>Search</Button>
                    </div> */}
                                </div>
                                {unsplashSearch === false ?
                                    <div className="row" style={{ width: '100%' }}>
                                        <div className="col-md-12">
                                            <img src={unsplash_logo} style={{ width: '10%', display: 'block', margin: '0 auto', marginTop: '17%' }}></img>
                                            <Typography variant="h4" sx={{ marginTop: '1%', textAlign: 'center', color: '#e5e7eb' }}>Unsplash</Typography>
                                            <Typography variant="h6" sx={{ marginTop: '1%', textAlign: 'center' }}>Try entering a search term, such as apple or daisy, to explore beautiful, high-resolution visuals.</Typography>{/* <br></br> */}

                                            <Typography variant="h6" sx={{ textAlign: 'center' }}>Once you've found an image you're happy with, click on it to add it to your workspace.</Typography>
                                            <Typography variant="h6" sx={{ textAlign: 'center' }} onClick={() => window.open('https://unsplash.com/', '_blank')}><a href="" style={{ textDecoration: 'none' }}>unsplash.com</a></Typography>
                                        </div>
                                    </div>
                                    :
                                    <div className="row" style={{ marginTop: '6%' }}>
                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
                                            gap: '10px',
                                            justifyContent: 'center'
                                        }}/* style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} */>
                                            {horizontalImages.map((image) => (
                                                <div key={image.id} className="thumbnail-container">
                                                    <img
                                                        className="thumbnail"
                                                        key={image.id}
                                                        src={modifyImageUrl(image.urls.thumb)}
                                                        alt={image.alt_description}
                                                        style={{ width: '100px', /* height: '100px', */ cursor: 'pointer', border: image.id === selectedUnsplashImg ? '3px solid #3b82f6' : '' }}
                                                        onClick={() => handleSelectUnsplashImage(image.urls.regular, image.id)}
                                                    />
                                                    <img
                                                        className="full-image"
                                                        src={image.urls.regular}
                                                        alt={image.alt_description}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                }

                                <div className="row" style={{ marginTop: '5%' }}>
                                    <div className={isMobile ? "col-6" : "col-sm-6 col-md-6 col-lg-6"}>
                                        <Button variant="contained" sx={{ fontWeight: 'bold' }} onClick={handleUnsplashselectionChange/* () => setOpenUnsplash(false) */}>Select</Button>
                                    </div>
                                    <div className={isMobile ? "col-6" : "col-sm-6 col-md-6 col-lg-6"}>
                                        <Button variant="contained" sx={{ fontWeight: 'bold' }} onClick={() => setOpenUnsplash(false)}>Close</Button>
                                    </div>
                                </div>
                            </Box>
                        </Modal>
                        {/* end unsplash and local image selection */}

                        {/* end modals */}
                    </div>
                </div>
            </div>
        </>
    );
}
